export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export type Query = {
  __typename: 'Query';
  test?: Maybe<TestResult>;
  menu?: Maybe<Menu>;
  config?: Maybe<TermFrontend>;
  searchByCategory?: Maybe<SearchByCategoryResult>;
  search?: Maybe<SearchResult>;
  getHotelById?: Maybe<Hotel>;
  route?: Maybe<RouteResult>;
  autocomplete?: Maybe<AutocompleteResult>;
  redirect?: Maybe<Redirect>;
  getProductDownload?: Maybe<ProductDownloadResult>;
  infolino?: Maybe<InfolinoResult>;
  loadMoreComments: Array<Comment>;
  loadMorePassTable?: Maybe<PoiConnection>;
  idQuery?: Maybe<Scalars['String']>;
  adSlotTerms: Array<TermAdSlot>;
  footerParagraphs?: Maybe<Array<Maybe<GlobalLayoutParagraphItem>>>;
};


export type QueryMenuArgs = {
  id: Scalars['String'];
};


export type QueryConfigArgs = {
  frontend: Scalars['String'];
};


export type QuerySearchByCategoryArgs = {
  category: Scalars['String'];
  frontend: Scalars['String'];
};


export type QueryGetHotelByIdArgs = {
  id: Scalars['Int'];
};


export type QueryRouteArgs = {
  path: Scalars['String'];
  frontend: Scalars['String'];
};


export type QueryRedirectArgs = {
  path: Scalars['String'];
  frontend: Scalars['String'];
};


export type QueryGetProductDownloadArgs = {
  id: Scalars['Int'];
  password?: Maybe<Scalars['String']>;
};


export type QueryInfolinoArgs = {
  path: Scalars['String'];
};


export type QueryLoadMoreCommentsArgs = {
  entityId: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryLoadMorePassTableArgs = {
  paragraphId: Scalars['Int'];
  parameters?: Maybe<PassTableParameters>;
};


export type QueryIdQueryArgs = {
  frontend: Scalars['String'];
  id: Scalars['Int'];
};


export type QueryFooterParagraphsArgs = {
  frontend: Scalars['String'];
};

export type TestResult = {
  __typename: 'TestResult';
  test1: Scalars['String'];
  test2: Scalars['String'];
};

export type Menu = {
  __typename: 'Menu';
  name: Scalars['String'];
  items?: Maybe<Array<Maybe<MenuItem>>>;
};

export type MenuItem = {
  __typename: 'MenuItem';
  title: Scalars['String'];
  url: Scalars['String'];
  children?: Maybe<Array<Maybe<MenuItem>>>;
};


export type MenuItemUrlArgs = {
  frontend: Scalars['String'];
};

export type TermFrontend = TermInterface & {
  __typename: 'TermFrontend';
  id: Scalars['Int'];
  name: Scalars['String'];
  frontendUrl?: Maybe<Scalars['String']>;
  defaultActivityImage?: Maybe<MediaImage>;
};

export type TermInterface = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MediaImage = MediaInterface & {
  __typename: 'MediaImage';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  imageTitle?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  width: Scalars['Int'];
  height: Scalars['Int'];
  imageStyle?: Maybe<ImageDerivative>;
  useNameAsCaption?: Maybe<Scalars['Boolean']>;
};


export type MediaImageImageStyleArgs = {
  name: ImageStyle;
};

export type MediaInterface = {
  id: Scalars['Int'];
  url: Scalars['String'];
};

export enum ImageStyle {
  Teaser = 'TEASER',
  TeaserLarge = 'TEASER_LARGE',
  TeaserHuge = 'TEASER_HUGE',
  TeaserSquare = 'TEASER_SQUARE',
  TeaserSquareSmall = 'TEASER_SQUARE_SMALL',
  PageHeaderBigThumb = 'PAGE_HEADER_BIG_THUMB',
  PageHeaderSmallThumb = 'PAGE_HEADER_SMALL_THUMB',
  PageHeaderSmallNoSidebarThumb = 'PAGE_HEADER_SMALL_NO_SIDEBAR_THUMB',
  PageHeaderMediumThumb = 'PAGE_HEADER_MEDIUM_THUMB',
  PageHeaderMediumNoSidebarThumb = 'PAGE_HEADER_MEDIUM_NO_SIDEBAR_THUMB',
  PageHeaderTinyThumb = 'PAGE_HEADER_TINY_THUMB',
  Full = 'FULL',
  HeroImage = 'HERO_IMAGE',
  HeroLarge = 'HERO_LARGE',
  ImageTextTeaser = 'IMAGE_TEXT_TEASER',
  ImageTextTeaserSmall = 'IMAGE_TEXT_TEASER_SMALL',
  Inline = 'INLINE',
  InlineOriginal = 'INLINE_ORIGINAL',
  InlineWithText = 'INLINE_WITH_TEXT',
  ProductTeaser = 'PRODUCT_TEASER',
  Thumbnail = 'THUMBNAIL',
  ThumbnailOriginal = 'THUMBNAIL_ORIGINAL',
  Medium = 'MEDIUM'
}

export type ImageDerivative = {
  __typename: 'ImageDerivative';
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type SearchByCategoryResult = {
  __typename: 'SearchByCategoryResult';
  categories?: Maybe<Array<TermCategory>>;
  category?: Maybe<TermCategory>;
  result?: Maybe<HotelActivityPoiConnection>;
};


export type SearchByCategoryResultCategoriesArgs = {
  frontend: Scalars['String'];
};


export type SearchByCategoryResultResultArgs = {
  filter?: Maybe<FilterInputGrouped>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};

export type TermCategory = TermInterface & {
  __typename: 'TermCategory';
  id: Scalars['Int'];
  name: Scalars['String'];
  frontendUrl?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  key?: Maybe<Scalars['String']>;
  parent?: Maybe<TermCategory>;
  parentId?: Maybe<Scalars['Int']>;
  labelPlural: Scalars['String'];
  question: Scalars['String'];
  searchPageUrl?: Maybe<Scalars['String']>;
  groupSearchPageUrl?: Maybe<Scalars['String']>;
};


export type TermCategorySearchPageUrlArgs = {
  frontend: Scalars['String'];
};


export type TermCategoryGroupSearchPageUrlArgs = {
  frontend: Scalars['String'];
};

export type FilterInputGrouped = {
  conditions?: Maybe<Array<EntityFilter>>;
  scopes?: Maybe<Array<Scope>>;
  conjunction?: Maybe<Conjunction>;
  groups?: Maybe<Array<Maybe<FilterInputGrouped>>>;
};

export type EntityFilter = {
  field: Scalars['String'];
  value: Scalars['String'];
  operator: Scalars['String'];
};

export type Scope = {
  name: Scalars['String'];
  parameters?: Maybe<Array<Maybe<Paramater>>>;
};

export type Paramater = {
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export enum Conjunction {
  Or = 'OR',
  And = 'AND'
}

export type Sort = {
  field?: Maybe<Scalars['String']>;
  direction?: Maybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
  Random = 'RANDOM'
}

export type HotelActivityPoiConnection = {
  __typename: 'HotelActivityPoiConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<ActivityHotelPoi>>>;
  activeFilters?: Maybe<Array<Maybe<ActiveFilter>>>;
};

export type ActivityHotelPoi = Activity | Hotel | Poi;

export type Activity = EntityInterface & {
  __typename: 'Activity';
  id: Scalars['Int'];
  title: Scalars['String'];
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  url: Scalars['String'];
  old_id?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  images?: Maybe<Array<MediaImage>>;
  frontends: Array<TermFrontend>;
  gpx?: Maybe<MediaGps>;
  category?: Maybe<TermCategory>;
  country?: Maybe<TermCountry>;
  location?: Maybe<FieldLocation>;
  polyline?: Maybe<FieldLocation>;
  region?: Maybe<TermRegion>;
  difficulty?: Maybe<TermDifficulty>;
  teaserImage?: Maybe<MediaImage>;
  length?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  isOffroad?: Maybe<Scalars['Boolean']>;
  hotels?: Maybe<HotelConnection>;
  nearActivities?: Maybe<ActivityConnection>;
  nearPois?: Maybe<PoiConnection>;
  nearHotels?: Maybe<HotelConnection>;
  elevationData?: Maybe<Scalars['String']>;
  productsInRegion?: Maybe<ProductConnection>;
  product?: Maybe<Product>;
  activitiesInRegion?: Maybe<ActivityConnection>;
  poisInRegion?: Maybe<PoiConnection>;
  useArticleLayout?: Maybe<Scalars['Boolean']>;
  sidebarBlocks: Array<ParagraphSidebarBlock>;
  content: Array<ActivityPoiContentParagraphs>;
  comments: Array<Comment>;
  totalComments: Scalars['Int'];
  globalParagraphs?: Maybe<Array<GlobalSlotParagraphs>>;
  authors?: Maybe<Array<Maybe<Person>>>;
  partner?: Maybe<TermPartner>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type ActivityMetatagsArgs = {
  frontend: Scalars['String'];
};


export type ActivityHotelsArgs = {
  frontend: Scalars['String'];
};


export type ActivityNearActivitiesArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type ActivityNearPoisArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type ActivityNearHotelsArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type ActivityActivitiesInRegionArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
};


export type ActivityPoisInRegionArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
};


export type ActivityGlobalParagraphsArgs = {
  frontend: Scalars['String'];
  slot: Scalars['String'];
};

export type EntityInterface = {
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Metatag = {
  __typename: 'Metatag';
  tag: Scalars['String'];
  attributes: MetatagAttribute;
};

export type MetatagAttribute = {
  __typename: 'MetatagAttribute';
  name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  rel?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
};

export type MediaGps = MediaInterface & {
  __typename: 'MediaGPS';
  id: Scalars['Int'];
  url: Scalars['String'];
};

export type TermCountry = TermInterface & {
  __typename: 'TermCountry';
  id: Scalars['Int'];
  name: Scalars['String'];
  isocode: Scalars['String'];
};

export type FieldLocation = {
  __typename: 'FieldLocation';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  bottom?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TermRegion = TermInterface & {
  __typename: 'TermRegion';
  id: Scalars['Int'];
  name: Scalars['String'];
  country?: Maybe<TermCountry>;
  image?: Maybe<MediaImage>;
  location?: Maybe<FieldLocation>;
  body?: Maybe<Scalars['String']>;
};

export type TermDifficulty = TermInterface & {
  __typename: 'TermDifficulty';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type HotelConnection = {
  __typename: 'HotelConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Hotel>>>;
};

export type Hotel = EntityInterface & {
  __typename: 'Hotel';
  id: Scalars['Int'];
  url: Scalars['String'];
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  fullUrl: Scalars['String'];
  title: Scalars['String'];
  activities?: Maybe<Array<Activity>>;
  activitiesFreizeithotels?: Maybe<Array<Activity>>;
  poisFreizeithotels?: Maybe<Array<Poi>>;
  pois?: Maybe<Array<Poi>>;
  category?: Maybe<TermCategory>;
  old_id?: Maybe<Scalars['String']>;
  beds?: Maybe<Scalars['Int']>;
  details?: Maybe<Array<HotelDetail>>;
  facebookPageUrl?: Maybe<Scalars['String']>;
  onlineBookingUrl?: Maybe<Scalars['String']>;
  detailsForFrontend?: Maybe<HotelDetail>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  features?: Maybe<Array<TermHotelFeature>>;
  featuresForFrontend?: Maybe<Array<TermHotelFeature>>;
  highlightedFeatures?: Maybe<Array<TermHotelFeature>>;
  highlightedFeaturesForFrontend?: Maybe<Array<TermHotelFeature>>;
  company?: Maybe<Scalars['String']>;
  frontends: Array<TermFrontend>;
  homepage?: Maybe<Scalars['String']>;
  kns?: Maybe<Scalars['String']>;
  country?: Maybe<TermCountry>;
  location?: Maybe<FieldLocation>;
  lastname?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  region?: Maybe<TermRegion>;
  stars?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
  teaserImage?: Maybe<MediaImage>;
  testimonialImage?: Maybe<MediaImage>;
  phone?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  rooms?: Maybe<Array<HotelRoom>>;
  ratings?: Maybe<RatingConnection>;
  averageRating?: Maybe<AverageRating>;
  maxRating?: Maybe<Scalars['Int']>;
  nearActivities?: Maybe<ActivityConnection>;
  nearPois?: Maybe<PoiConnection>;
  offers?: Maybe<Array<Offers>>;
  offersForFrontend?: Maybe<Array<Offers>>;
  minPrice?: Maybe<Scalars['Int']>;
  activitiesInRegion?: Maybe<ActivityConnection>;
  productsInRegion?: Maybe<ProductConnection>;
  poisInRegion?: Maybe<PoiConnection>;
  onlyShowOnlineBooking?: Maybe<Scalars['Boolean']>;
};


export type HotelMetatagsArgs = {
  frontend: Scalars['String'];
};


export type HotelFullUrlArgs = {
  frontend: Scalars['String'];
};


export type HotelDetailsForFrontendArgs = {
  frontend?: Maybe<Scalars['String']>;
};


export type HotelFeaturesForFrontendArgs = {
  frontend: Scalars['String'];
};


export type HotelHighlightedFeaturesForFrontendArgs = {
  frontend: Scalars['String'];
};


export type HotelRatingsArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  onlyPushed?: Maybe<Scalars['Boolean']>;
};


export type HotelNearActivitiesArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type HotelNearPoisArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type HotelOffersForFrontendArgs = {
  frontend?: Maybe<Scalars['String']>;
};


export type HotelActivitiesInRegionArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
};


export type HotelPoisInRegionArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
};

export type Poi = EntityInterface & {
  __typename: 'Poi';
  id: Scalars['Int'];
  title: Scalars['String'];
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  url: Scalars['String'];
  old_id?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  images?: Maybe<Array<MediaImage>>;
  frontends: Array<TermFrontend>;
  gpx?: Maybe<MediaGps>;
  category?: Maybe<TermCategory>;
  isPass?: Maybe<Scalars['Boolean']>;
  isOffroad?: Maybe<Scalars['Boolean']>;
  country?: Maybe<TermCountry>;
  location?: Maybe<FieldLocation>;
  region?: Maybe<TermRegion>;
  teaserImage?: Maybe<MediaImage>;
  length?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  hotels?: Maybe<HotelConnection>;
  nearActivities?: Maybe<ActivityConnection>;
  nearPois?: Maybe<PoiConnection>;
  nearHotels?: Maybe<HotelConnection>;
  activitiesInRegion?: Maybe<ActivityConnection>;
  poisInRegion?: Maybe<PoiConnection>;
  productsInRegion?: Maybe<ProductConnection>;
  elevationData?: Maybe<Scalars['String']>;
  useArticleLayout?: Maybe<Scalars['Boolean']>;
  sidebarBlocks: Array<ParagraphSidebarBlock>;
  content: Array<ActivityPoiContentParagraphs>;
  passHeight?: Maybe<Scalars['Int']>;
  maxSlope?: Maybe<Scalars['Float']>;
  winterClosure?: Maybe<Scalars['String']>;
  basePlaces?: Maybe<Scalars['String']>;
  toll?: Maybe<Scalars['Boolean']>;
  tollPrices?: Maybe<Scalars['String']>;
  unpaved?: Maybe<Scalars['Boolean']>;
  numberOfTurns?: Maybe<Scalars['Int']>;
  deadEnd?: Maybe<Scalars['Boolean']>;
  restrictions?: Maybe<Scalars['String']>;
  stars?: Maybe<Scalars['Int']>;
  difficulty?: Maybe<TermDifficulty>;
  comments: Array<Comment>;
  totalComments: Scalars['Int'];
  globalParagraphs?: Maybe<Array<GlobalSlotParagraphs>>;
  authors?: Maybe<Array<Maybe<Person>>>;
  partner?: Maybe<TermPartner>;
  updatedAt?: Maybe<Scalars['String']>;
  offroadCars?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PoiMetatagsArgs = {
  frontend: Scalars['String'];
};


export type PoiHotelsArgs = {
  frontend: Scalars['String'];
};


export type PoiNearActivitiesArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type PoiNearPoisArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type PoiNearHotelsArgs = {
  frontend: Scalars['String'];
  limit: Scalars['Int'];
};


export type PoiActivitiesInRegionArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
};


export type PoiPoisInRegionArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
};


export type PoiGlobalParagraphsArgs = {
  frontend: Scalars['String'];
  slot: Scalars['String'];
};

export type ActivityConnection = {
  __typename: 'ActivityConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Activity>>>;
};

export type PoiConnection = {
  __typename: 'PoiConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Poi>>>;
  countries: Array<TermCountry>;
  regions: Array<TermRegion>;
  activeFilters?: Maybe<Array<Maybe<ActiveFilter>>>;
};

export type ActiveFilter = {
  __typename: 'ActiveFilter';
  field: Scalars['String'];
  operator: Scalars['String'];
  value: Scalars['String'];
  label: Scalars['String'];
};

export type ProductConnection = {
  __typename: 'ProductConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Product>>>;
};

export type Product = EntityInterface & {
  __typename: 'Product';
  id: Scalars['Int'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  productCategory: TermProductCategory;
  externalLink?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  teaserImage?: Maybe<MediaImage>;
  images?: Maybe<Array<MediaImage>>;
  gpxFiles?: Maybe<Array<MediaGps>>;
  body?: Maybe<Scalars['String']>;
  downloadText?: Maybe<Scalars['String']>;
  downloadPassword?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  content: Array<ParagraphInterface>;
  productsInRegion?: Maybe<ProductConnection>;
};


export type ProductMetatagsArgs = {
  frontend: Scalars['String'];
};

export type TermProductCategory = TermInterface & {
  __typename: 'TermProductCategory';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ParagraphInterface = {
  id: Scalars['Int'];
};

export type ParagraphSidebarBlock = ParagraphInterface & {
  __typename: 'ParagraphSidebarBlock';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  content: Array<SidebarBlockParagraphs>;
};

export type SidebarBlockParagraphs = ParagraphActivityPoiNearHotels | ParagraphCustomTeaserList | ParagraphImageTextTeaser | ParagraphLinks | ParagraphText | ParagraphAdSlot;

export type ParagraphActivityPoiNearHotels = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiNearHotels';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphCustomTeaserList = ParagraphInterface & {
  __typename: 'ParagraphCustomTeaserList';
  id: Scalars['Int'];
  content?: Maybe<Array<Maybe<ParagraphCustomTeaserListItem>>>;
};

export type ParagraphCustomTeaserListItem = ParagraphInterface & {
  __typename: 'ParagraphCustomTeaserListItem';
  id: Scalars['Int'];
  title: Scalars['String'];
  image: MediaImage;
  body: Scalars['String'];
  linkUrl: Scalars['String'];
  linkText?: Maybe<Scalars['String']>;
};


export type ParagraphCustomTeaserListItemLinkUrlArgs = {
  frontend: Scalars['String'];
};

export type ParagraphImageTextTeaser = ParagraphInterface & {
  __typename: 'ParagraphImageTextTeaser';
  id: Scalars['Int'];
  body?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  linkText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  category?: Maybe<TermCategory>;
  customLink?: Maybe<Scalars['String']>;
};


export type ParagraphImageTextTeaserCustomLinkArgs = {
  frontend: Scalars['String'];
};

export type ParagraphLinks = ParagraphInterface & {
  __typename: 'ParagraphLinks';
  id: Scalars['Int'];
  links?: Maybe<Array<ParagraphLink>>;
};

export type ParagraphLink = ParagraphInterface & {
  __typename: 'ParagraphLink';
  id: Scalars['Int'];
  link?: Maybe<Link>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
};

export type Link = {
  __typename: 'Link';
  url: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};


export type LinkUrlArgs = {
  frontend: Scalars['String'];
};

export type ParagraphText = ParagraphInterface & {
  __typename: 'ParagraphText';
  id: Scalars['Int'];
  body?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  addToTableOfContents?: Maybe<Scalars['Boolean']>;
};

export type ParagraphAdSlot = ParagraphInterface & {
  __typename: 'ParagraphAdSlot';
  id: Scalars['Int'];
  slot: TermAdSlot;
};

export type TermAdSlot = TermInterface & {
  __typename: 'TermAdSlot';
  id: Scalars['Int'];
  name: Scalars['String'];
  format: Scalars['String'];
  responsive: Scalars['Boolean'];
  maxHeight?: Maybe<Scalars['Int']>;
  slotId: Scalars['String'];
  layout?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type ActivityPoiContentParagraphs = ParagraphActivityList | ParagraphActivityPoiTeaserList | ParagraphActivitySlider | ParagraphActivityTabs | ParagraphColumns | ParagraphActivityPoiActivitiesInRegion | ParagraphActivityPoiImages | ParagraphCustomTeaserList | ParagraphActivityPoiMap | ParagraphActivityPoiNearHotels | ParagraphActivityPoiPoisInRegion | ParagraphActivityPoiProductsInRegion | ParagraphFormular | ParagraphFromLibrary | ParagraphHotelList | ParagraphHotelOffers | ParagraphImage | ParagraphImageAndText | ParagraphImageTextTeaser | ParagraphLinks | ParagraphMerchantList | ParagraphNewsList | ParagraphProductList | ParagraphRegionTeaserList | ParagraphText | ParagraphCommentListAndFormular | ParagraphActivityPoiNearActivities | ParagraphActivityPoiNearPois | ParagraphPoiPassProfile | ParagraphCommentBox | ParagraphInfoBox | ParagraphAuthors | ParagraphPartner | ParagraphAdSlot | ParagraphFaq | ParagraphPartnerList;

export type ParagraphActivityList = ParagraphInterface & {
  __typename: 'ParagraphActivityList';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  category?: Maybe<TermCategory>;
  data?: Maybe<ActivityConnection>;
  linktext?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
};


export type ParagraphActivityListDataArgs = {
  frontend: Scalars['String'];
};

export type ParagraphActivityPoiTeaserList = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiTeaserList';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  teaser?: Maybe<Array<ParagraphActivityPoiTeaser>>;
};

export type ParagraphActivityPoiTeaser = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiTeaser';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  termReference?: Maybe<TermCategory>;
};

export type ParagraphActivitySlider = ParagraphInterface & {
  __typename: 'ParagraphActivitySlider';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  data?: Maybe<ActivityConnection>;
};


export type ParagraphActivitySliderDataArgs = {
  frontend: Scalars['String'];
};

export type ParagraphActivityTabs = ParagraphInterface & {
  __typename: 'ParagraphActivityTabs';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  limitPerCategory: Scalars['Int'];
  categories: Array<ParagraphSearchCategory>;
  categoryItems?: Maybe<Array<ParagraphActivityTabData>>;
};


export type ParagraphActivityTabsCategoryItemsArgs = {
  frontend: Scalars['String'];
};

export type ParagraphSearchCategory = ParagraphInterface & {
  __typename: 'ParagraphSearchCategory';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  category?: Maybe<TermCategory>;
  searchIndex: Scalars['String'];
};

export type ParagraphActivityTabData = {
  __typename: 'ParagraphActivityTabData';
  category?: Maybe<TermCategory>;
  items: Array<Activity>;
};

export type ParagraphColumns = ParagraphInterface & {
  __typename: 'ParagraphColumns';
  id: Scalars['Int'];
  content: Array<ParagraphColumn>;
};

export type ParagraphColumn = ParagraphInterface & {
  __typename: 'ParagraphColumn';
  id: Scalars['Int'];
  content: Array<ColumnContentParagraphs>;
};

export type ColumnContentParagraphs = ParagraphText | ParagraphImageTextTeaser | ParagraphImage | ParagraphImageAndText | ParagraphLinks | ParagraphAuthors | ParagraphPartner | ParagraphAdSlot | ParagraphPartnerList;

export type ParagraphImage = ParagraphInterface & {
  __typename: 'ParagraphImage';
  id: Scalars['Int'];
  image?: Maybe<MediaImage>;
  viewmode?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type ParagraphImageAndText = ParagraphInterface & {
  __typename: 'ParagraphImageAndText';
  id: Scalars['Int'];
  image?: Maybe<MediaImage>;
  body?: Maybe<Scalars['String']>;
  imagePosition: Scalars['String'];
};

export type ParagraphAuthors = ParagraphInterface & {
  __typename: 'ParagraphAuthors';
  id: Scalars['Int'];
};

export type ParagraphPartner = ParagraphInterface & {
  __typename: 'ParagraphPartner';
  id: Scalars['Int'];
};

export type ParagraphPartnerList = ParagraphInterface & {
  __typename: 'ParagraphPartnerList';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  partner: Array<Maybe<TermPartner>>;
};

export type TermPartner = TermInterface & {
  __typename: 'TermPartner';
  id: Scalars['Int'];
  name: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  image: MediaImage;
  externalUrl?: Maybe<Scalars['String']>;
};

export type ParagraphActivityPoiActivitiesInRegion = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiActivitiesInRegion';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphActivityPoiImages = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiImages';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphActivityPoiMap = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiMap';
  id: Scalars['Int'];
};

export type ParagraphActivityPoiPoisInRegion = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiPoisInRegion';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphActivityPoiProductsInRegion = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiProductsInRegion';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphFormular = ParagraphInterface & {
  __typename: 'ParagraphFormular';
  id: Scalars['Int'];
  formular: Scalars['String'];
  textConfirm: Scalars['String'];
  textError: Scalars['String'];
};

export type ParagraphFromLibrary = ParagraphInterface & {
  __typename: 'ParagraphFromLibrary';
  id: Scalars['Int'];
  paragraph: ParagraphFromLibraryItem;
};

export type ParagraphFromLibraryItem = {
  __typename: 'ParagraphFromLibraryItem';
  id: Scalars['Int'];
  title: Scalars['String'];
  content: Array<ParagraphInterface>;
};

export type ParagraphHotelList = ParagraphInterface & {
  __typename: 'ParagraphHotelList';
  id: Scalars['Int'];
  limit: Scalars['Int'];
  category?: Maybe<TermCategory>;
  data?: Maybe<HotelConnection>;
  linktext?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
};


export type ParagraphHotelListDataArgs = {
  frontend: Scalars['String'];
};

export type ParagraphHotelOffers = ParagraphInterface & {
  __typename: 'ParagraphHotelOffers';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  data?: Maybe<OffersConnection>;
};


export type ParagraphHotelOffersDataArgs = {
  frontend: Scalars['String'];
};

export type OffersConnection = {
  __typename: 'OffersConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Offers>>>;
};

export type Offers = EntityInterface & {
  __typename: 'Offers';
  id: Scalars['Int'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  hotel?: Maybe<Hotel>;
  price?: Maybe<Scalars['Float']>;
  image?: Maybe<MediaImage>;
  dateRange?: Maybe<FieldDate>;
};

export type FieldDate = {
  __typename: 'FieldDate';
  value?: Maybe<Scalars['String']>;
  end_value?: Maybe<Scalars['String']>;
};

export type ParagraphMerchantList = ParagraphInterface & {
  __typename: 'ParagraphMerchantList';
  id: Scalars['Int'];
  merchants?: Maybe<MerchantConnection>;
};


export type ParagraphMerchantListMerchantsArgs = {
  frontend: Scalars['String'];
};

export type MerchantConnection = {
  __typename: 'MerchantConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Merchant>>>;
};

export type Merchant = EntityInterface & {
  __typename: 'Merchant';
  id: Scalars['Int'];
  title: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  street: Scalars['String'];
  country?: Maybe<TermCountry>;
  region?: Maybe<TermRegion>;
  postcode?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  location?: Maybe<FieldLocation>;
  phone?: Maybe<Scalars['String']>;
  homepage?: Maybe<Scalars['String']>;
};

export type ParagraphNewsList = ParagraphInterface & {
  __typename: 'ParagraphNewsList';
  id: Scalars['Int'];
  limit: Scalars['Int'];
  data?: Maybe<NewsConnection>;
};


export type ParagraphNewsListDataArgs = {
  frontend: Scalars['String'];
};

export type NewsConnection = {
  __typename: 'NewsConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<News>>>;
};

export type News = EntityInterface & {
  __typename: 'News';
  id: Scalars['Int'];
  title: Scalars['String'];
  created?: Maybe<Scalars['String']>;
  content?: Maybe<Array<ContentParagraphs>>;
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  frontend?: Maybe<TermFrontend>;
  url: Scalars['String'];
  teaserImage?: Maybe<MediaImage>;
  tags?: Maybe<Array<TermTag>>;
  category?: Maybe<TermCategory>;
  teaserText?: Maybe<Scalars['String']>;
  authors?: Maybe<Array<Maybe<Person>>>;
  partner?: Maybe<TermPartner>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type NewsMetatagsArgs = {
  frontend: Scalars['String'];
};


export type NewsUrlArgs = {
  frontend: Scalars['String'];
};

export type ContentParagraphs = ParagraphHotelOffers | ParagraphActivitySlider | ParagraphActivityPoiTeaserList | ParagraphHero | ParagraphText | ParagraphActivityList | ParagraphHotelList | ParagraphActivityTabs | ParagraphFormular | ParagraphRegionTeaserList | ParagraphMerchantList | ParagraphColumns | ParagraphContainer | ParagraphSearchbar | ParagraphNewsletter | ParagraphHeader | ParagraphTestimonial | ParagraphSearchResults | ParagraphImage | ParagraphNewsList | ParagraphImageAndText | ParagraphCustomTeaserList | ParagraphProductList | ParagraphEyeCatcher | ParagraphLinks | ParagraphFromLibrary | ParagraphPassTable | ParagraphPassMap | ParagraphPassListMap | ParagraphSearchById | ParagraphCommentBox | ParagraphInfoBox | ParagraphAuthors | ParagraphPartner | ParagraphAdSlot | ParagraphFaq | ParagraphPartnerList;

export type ParagraphHero = ParagraphInterface & {
  __typename: 'ParagraphHero';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  categories: Array<ParagraphSearchCategory>;
  useNegativeLogoVersion?: Maybe<Scalars['Boolean']>;
};

export type ParagraphRegionTeaserList = ParagraphInterface & {
  __typename: 'ParagraphRegionTeaserList';
  id: Scalars['Int'];
  regionTeaserListItems?: Maybe<Array<ParagraphRegionTeaserListItem>>;
};

export type ParagraphRegionTeaserListItem = ParagraphInterface & {
  __typename: 'ParagraphRegionTeaserListItem';
  id: Scalars['Int'];
  region: TermRegion;
  linkUrl: Scalars['String'];
  linkText?: Maybe<Scalars['String']>;
};


export type ParagraphRegionTeaserListItemLinkUrlArgs = {
  frontend: Scalars['String'];
};

export type ParagraphContainer = ParagraphInterface & {
  __typename: 'ParagraphContainer';
  id: Scalars['Int'];
  content: Array<ContainerContentParagraphs>;
  size: Scalars['String'];
};

export type ContainerContentParagraphs = ParagraphText | ParagraphColumns | ParagraphImage | ParagraphImageAndText | ParagraphLinks | ParagraphFromLibrary | ParagraphCommentListAndFormular | ParagraphSearchById | ParagraphCommentBox | ParagraphInfoBox | ParagraphAuthors | ParagraphPartner | ParagraphAdSlot | ParagraphFaq | ParagraphPartnerList;

export type ParagraphCommentListAndFormular = ParagraphInterface & {
  __typename: 'ParagraphCommentListAndFormular';
  id: Scalars['Int'];
  headline?: Maybe<Scalars['String']>;
  comments: Array<Comment>;
  totalComments: Scalars['Int'];
};

export type Comment = {
  __typename: 'Comment';
  id: Scalars['Int'];
  subject?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  created: Scalars['Int'];
  thread: Scalars['String'];
  comment: Scalars['String'];
  parentComment?: Maybe<Comment>;
  images?: Maybe<Array<Maybe<MediaImage>>>;
  vehicle?: Maybe<Scalars['String']>;
  closures?: Maybe<Scalars['String']>;
  stars?: Maybe<Scalars['Int']>;
  tipps?: Maybe<Scalars['String']>;
  dateVisit?: Maybe<Scalars['String']>;
};

export type ParagraphSearchById = ParagraphInterface & {
  __typename: 'ParagraphSearchById';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphCommentBox = ParagraphInterface & {
  __typename: 'ParagraphCommentBox';
  id: Scalars['Int'];
  author?: Maybe<Person>;
  externalAuthor?: Maybe<Scalars['String']>;
  customLink?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type Person = EntityInterface & {
  __typename: 'Person';
  id: Scalars['Int'];
  title: Scalars['String'];
  homepageUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  job?: Maybe<Scalars['String']>;
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  teaserImage?: Maybe<MediaImage>;
  content: Array<ParagraphInterface>;
};


export type PersonMetatagsArgs = {
  frontend: Scalars['String'];
};

export type ParagraphInfoBox = ParagraphInterface & {
  __typename: 'ParagraphInfoBox';
  id: Scalars['Int'];
  colorSchema: Scalars['String'];
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphFaq = ParagraphInterface & {
  __typename: 'ParagraphFaq';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ParagraphFaqItem>>>;
  hideFrontend?: Maybe<Scalars['Boolean']>;
};

export type ParagraphFaqItem = ParagraphInterface & {
  __typename: 'ParagraphFaqItem';
  id: Scalars['Int'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
};

export type ParagraphSearchbar = ParagraphInterface & {
  __typename: 'ParagraphSearchbar';
  id: Scalars['Int'];
  headline?: Maybe<Scalars['String']>;
  showFilters?: Maybe<Scalars['Boolean']>;
  showMapButton?: Maybe<Scalars['Boolean']>;
  categories: Array<ParagraphSearchCategory>;
  categoriesLinkToSearchPage?: Maybe<Scalars['Boolean']>;
  showGroupSearch?: Maybe<Scalars['Boolean']>;
  groupSearchTitle?: Maybe<Scalars['String']>;
  groupSearchButtonTitle?: Maybe<Scalars['String']>;
};

export type ParagraphNewsletter = ParagraphInterface & {
  __typename: 'ParagraphNewsletter';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
};

export type ParagraphHeader = ParagraphInterface & {
  __typename: 'ParagraphHeader';
  id: Scalars['Int'];
  headline?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  showAddon?: Maybe<Scalars['Boolean']>;
  useNegativeLogoVersion?: Maybe<Scalars['Boolean']>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
};


export type ParagraphHeaderLinkUrlArgs = {
  frontend: Scalars['String'];
};

export type ParagraphTestimonial = ParagraphInterface & {
  __typename: 'ParagraphTestimonial';
  id: Scalars['Int'];
  image?: Maybe<MediaImage>;
  data?: Maybe<Rating>;
};


export type ParagraphTestimonialDataArgs = {
  frontend: Scalars['String'];
};

export type Rating = EntityInterface & {
  __typename: 'Rating';
  id: Scalars['Int'];
  title: Scalars['String'];
  reply?: Maybe<Scalars['String']>;
  dateRange?: Maybe<FieldDate>;
  body?: Maybe<Scalars['String']>;
  ratingKindness: Scalars['Int'];
  ratingHousing: Scalars['Int'];
  ratingCatering: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  hotel?: Maybe<Hotel>;
  lastname?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  publicName?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Int']>;
};

export type ParagraphSearchResults = ParagraphInterface & {
  __typename: 'ParagraphSearchResults';
  id: Scalars['Int'];
  result?: Maybe<HotelActivityPoiConnection>;
};


export type ParagraphSearchResultsResultArgs = {
  parameters?: Maybe<SearchParameters>;
};

export type SearchParameters = {
  filter?: Maybe<FilterInputGrouped>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
  searchQuery?: Maybe<Scalars['String']>;
};

export type ParagraphProductList = ParagraphInterface & {
  __typename: 'ParagraphProductList';
  id: Scalars['Int'];
  limit: Scalars['Int'];
  category: TermProductCategory;
  data?: Maybe<ProductConnection>;
  linkText?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
  title?: Maybe<Scalars['String']>;
  desktopAsSlider?: Maybe<Scalars['Boolean']>;
};

export type ParagraphEyeCatcher = ParagraphInterface & {
  __typename: 'ParagraphEyeCatcher';
  id: Scalars['Int'];
  headline?: Maybe<Scalars['String']>;
  alignment?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  contentImage?: Maybe<MediaImage>;
  image?: Maybe<MediaImage>;
  linkUrl?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
};

export type ParagraphPassTable = ParagraphInterface & {
  __typename: 'ParagraphPassTable';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  data?: Maybe<PoiConnection>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
};


export type ParagraphPassTableDataArgs = {
  parameters?: Maybe<PassTableParameters>;
};

export type PassTableParameters = {
  frontend: Scalars['String'];
  sort?: Maybe<Sort>;
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<FilterInputGrouped>;
  query?: Maybe<Scalars['String']>;
};

export type ParagraphPassMap = ParagraphInterface & {
  __typename: 'ParagraphPassMap';
  id: Scalars['Int'];
  data?: Maybe<PoiConnection>;
};


export type ParagraphPassMapDataArgs = {
  parameters?: Maybe<PassMapParameters>;
};

export type PassMapParameters = {
  frontend: Scalars['String'];
};

export type ParagraphPassListMap = ParagraphInterface & {
  __typename: 'ParagraphPassListMap';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  data?: Maybe<PoiConnection>;
  regions?: Maybe<Array<TermRegion>>;
  countries?: Maybe<Array<TermCountry>>;
};


export type ParagraphPassListMapDataArgs = {
  parameters?: Maybe<PassListMapParameters>;
};

export type PassListMapParameters = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  query?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
};

export type TermTag = TermInterface & {
  __typename: 'TermTag';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ParagraphActivityPoiNearActivities = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiNearActivities';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphActivityPoiNearPois = ParagraphInterface & {
  __typename: 'ParagraphActivityPoiNearPois';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphPoiPassProfile = ParagraphInterface & {
  __typename: 'ParagraphPoiPassProfile';
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type GlobalSlotParagraphs = ParagraphProductList | ParagraphFromLibrary | ParagraphAdSlot;

export type HotelDetail = {
  __typename: 'HotelDetail';
  id: Scalars['Int'];
  body?: Maybe<Scalars['String']>;
  images?: Maybe<Array<MediaImage>>;
  frontends?: Maybe<Array<TermFrontend>>;
};

export type TermHotelFeature = TermInterface & {
  __typename: 'TermHotelFeature';
  id: Scalars['Int'];
  name: Scalars['String'];
  frontends?: Maybe<Array<Maybe<TermFrontend>>>;
  category?: Maybe<TermHotelFeatureCategory>;
  icon?: Maybe<Scalars['String']>;
};

export type TermHotelFeatureCategory = TermInterface & {
  __typename: 'TermHotelFeatureCategory';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type HotelRoom = {
  __typename: 'HotelRoom';
  roomCount?: Maybe<Scalars['Int']>;
  prices?: Maybe<Array<HotelRoomPrice>>;
  roomType?: Maybe<TermRoomType>;
};

export type HotelRoomPrice = {
  __typename: 'HotelRoomPrice';
  description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  date?: Maybe<FieldDate>;
};

export type TermRoomType = TermInterface & {
  __typename: 'TermRoomType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type RatingConnection = {
  __typename: 'RatingConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Rating>>>;
};

export type AverageRating = {
  __typename: 'AverageRating';
  ratingCount: Scalars['Int'];
  total: Scalars['Float'];
  catering: Scalars['Float'];
  housing: Scalars['Float'];
  kindness: Scalars['Float'];
};

export type SearchResult = {
  __typename: 'SearchResult';
  result?: Maybe<HotelActivityPoiConnection>;
};


export type SearchResultResultArgs = {
  searchQuery: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};

export type RouteResult = {
  __typename: 'RouteResult';
  entity?: Maybe<NodeTypes>;
};

export type NodeTypes = Activity | Hotel | Rating | Offers | Page | Poi | News | Product | Person;

export type Page = EntityInterface & {
  __typename: 'Page';
  id: Scalars['Int'];
  title: Scalars['String'];
  frontend?: Maybe<TermFrontend>;
  content?: Maybe<Array<ContentParagraphs>>;
  showTitle?: Maybe<Scalars['Boolean']>;
  metatags?: Maybe<Array<Maybe<Metatag>>>;
  category?: Maybe<TermCategory>;
  url: Scalars['String'];
  isGroupSearch?: Maybe<Scalars['Boolean']>;
  authors?: Maybe<Array<Maybe<Person>>>;
  partner?: Maybe<TermPartner>;
  updatedAt?: Maybe<Scalars['String']>;
};


export type PageMetatagsArgs = {
  frontend: Scalars['String'];
};


export type PageUrlArgs = {
  frontend: Scalars['String'];
};

export type AutocompleteResult = {
  __typename: 'AutocompleteResult';
  result: HotelActivityPoiConnection;
  countries: CountryConnection;
  postcodes: PostcodeConnection;
  cities: CityConnection;
  regions: RegionConnection;
  features: FeatureConnection;
  geocodeResults: GeocodeResult;
};


export type AutocompleteResultResultArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  searchQuery: Scalars['String'];
  category: Scalars['String'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};


export type AutocompleteResultCountriesArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  searchQuery: Scalars['String'];
  category: Scalars['String'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};


export type AutocompleteResultPostcodesArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  searchQuery: Scalars['String'];
  category: Scalars['String'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};


export type AutocompleteResultCitiesArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  searchQuery: Scalars['String'];
  category: Scalars['String'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};


export type AutocompleteResultRegionsArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  searchQuery: Scalars['String'];
  category: Scalars['String'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};


export type AutocompleteResultFeaturesArgs = {
  frontend: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
  searchQuery: Scalars['String'];
  category: Scalars['String'];
  limit: Scalars['Int'];
  sort?: Maybe<Sort>;
};


export type AutocompleteResultGeocodeResultsArgs = {
  searchQuery: Scalars['String'];
};

export type CountryConnection = {
  __typename: 'CountryConnection';
  total: Scalars['Int'];
  items: Array<TermCountry>;
};

export type PostcodeConnection = {
  __typename: 'PostcodeConnection';
  total: Scalars['Int'];
  items: Array<TermPostcode>;
};

export type TermPostcode = TermInterface & {
  __typename: 'TermPostcode';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CityConnection = {
  __typename: 'CityConnection';
  total: Scalars['Int'];
  items: Array<TermCity>;
};

export type TermCity = TermInterface & {
  __typename: 'TermCity';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type RegionConnection = {
  __typename: 'RegionConnection';
  total: Scalars['Int'];
  items: Array<TermRegion>;
};

export type FeatureConnection = {
  __typename: 'FeatureConnection';
  total: Scalars['Int'];
  items: Array<TermHotelActivityFeature>;
};

export type TermHotelActivityFeature = TermHotelFeature | TermActivityFeature;

export type TermActivityFeature = TermInterface & {
  __typename: 'TermActivityFeature';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GeocodeResult = {
  __typename: 'GeocodeResult';
  features: Array<GeocodeResultFeature>;
};

export type GeocodeResultFeature = {
  __typename: 'GeocodeResultFeature';
  geometry: GeocodeResultFeatureGeometry;
  properties: GeocodeResultFeatureProperties;
  id: Scalars['String'];
};

export type GeocodeResultFeatureGeometry = {
  __typename: 'GeocodeResultFeatureGeometry';
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type GeocodeResultFeatureProperties = {
  __typename: 'GeocodeResultFeatureProperties';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  osm_id?: Maybe<Scalars['Int']>;
  osm_key?: Maybe<Scalars['String']>;
  osm_type?: Maybe<Scalars['String']>;
  osm_value?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
};

export type Redirect = {
  __typename: 'Redirect';
  statusCode: Scalars['Int'];
  destination: Scalars['String'];
};

export type ProductDownloadResult = {
  __typename: 'ProductDownloadResult';
  error?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type InfolinoResult = {
  __typename: 'InfolinoResult';
  hotel: Hotel;
  logo?: Maybe<MediaImage>;
  color?: Maybe<Scalars['String']>;
  page?: Maybe<InfolinoPage>;
  menu?: Maybe<Array<InfolinoPage>>;
  baseUrl?: Maybe<Scalars['String']>;
  imageBorder?: Maybe<Scalars['Boolean']>;
};

export type InfolinoPage = {
  __typename: 'InfolinoPage';
  url: Scalars['String'];
  title: Scalars['String'];
  isHomepage: Scalars['Boolean'];
  hideInMenu: Scalars['Boolean'];
  image: MediaImage;
  link?: Maybe<Link>;
  content?: Maybe<Array<InfolinoContentParagraphs>>;
};

export type InfolinoContentParagraphs = ParagraphContainer | ParagraphColumns | ParagraphImage | ParagraphImageAndText | ParagraphImageTextTeaser | ParagraphLinks | ParagraphSpacer | ParagraphText | ParagraphInfolinoActivities | ParagraphInfolinoContact | ParagraphInfolinoRating | ParagraphInfolinoPoIs | ParagraphInfolinoWellnessFormular | ParagraphInfolinoFeedbackFormular;

export type ParagraphSpacer = ParagraphInterface & {
  __typename: 'ParagraphSpacer';
  id: Scalars['Int'];
  showBorder: Scalars['Boolean'];
  size: Scalars['String'];
};

export type ParagraphInfolinoActivities = ParagraphInterface & {
  __typename: 'ParagraphInfolinoActivities';
  id: Scalars['Int'];
};

export type ParagraphInfolinoContact = ParagraphInterface & {
  __typename: 'ParagraphInfolinoContact';
  id: Scalars['Int'];
};

export type ParagraphInfolinoRating = ParagraphInterface & {
  __typename: 'ParagraphInfolinoRating';
  id: Scalars['Int'];
};

export type ParagraphInfolinoPoIs = ParagraphInterface & {
  __typename: 'ParagraphInfolinoPOIs';
  id: Scalars['Int'];
};

export type ParagraphInfolinoWellnessFormular = ParagraphInterface & {
  __typename: 'ParagraphInfolinoWellnessFormular';
  id: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  treatments: Array<Scalars['String']>;
};

export type ParagraphInfolinoFeedbackFormular = ParagraphInterface & {
  __typename: 'ParagraphInfolinoFeedbackFormular';
  id: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  ratingCategories: Array<Scalars['String']>;
};

export type GlobalLayoutParagraphItem = ParagraphPartnerList | ParagraphFromLibrary;

export type Mutation = {
  __typename: 'Mutation';
  createBooking?: Maybe<CreateBookingResult>;
  createRating?: Maybe<CreateRatingResult>;
  createOrder?: Maybe<CreateOrderResult>;
  createInfolinoFeedback?: Maybe<CreateInfolinoFeedbackResult>;
  createInfolinoWellness?: Maybe<CreateInfolinoWellnessResult>;
  createComment?: Maybe<CreateCommentResult>;
};


export type MutationCreateBookingArgs = {
  data?: Maybe<CreateBookingInput>;
};


export type MutationCreateRatingArgs = {
  data?: Maybe<CreateRatingInput>;
};


export type MutationCreateOrderArgs = {
  data?: Maybe<CreateOrderInput>;
};


export type MutationCreateInfolinoFeedbackArgs = {
  data?: Maybe<CreateInfolinoFeedbackInput>;
};


export type MutationCreateInfolinoWellnessArgs = {
  data?: Maybe<CreateInfolinoWellnessInput>;
};


export type MutationCreateCommentArgs = {
  data?: Maybe<CreateCommentInput>;
};

export type CreateBookingInput = {
  hotel: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  date_range: DateInput;
  rooms_count: Scalars['String'];
  beds: Scalars['String'];
  body?: Maybe<Scalars['String']>;
  frontend?: Maybe<Scalars['String']>;
};

export type DateInput = {
  value?: Maybe<Scalars['String']>;
  end_value?: Maybe<Scalars['String']>;
};

export type CreateBookingResult = {
  __typename: 'CreateBookingResult';
  created: Scalars['Boolean'];
  errors?: Maybe<Array<Violation>>;
};

export type Violation = {
  __typename: 'Violation';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type CreateRatingInput = {
  hotel: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  rating_kindness: Scalars['Int'];
  rating_housing: Scalars['Int'];
  rating_catering: Scalars['Int'];
  public_name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  date_range: DateInput;
  body?: Maybe<Scalars['String']>;
  frontend?: Maybe<Scalars['String']>;
};

export type CreateRatingResult = {
  __typename: 'CreateRatingResult';
  created: Scalars['Boolean'];
  errors?: Maybe<Array<Violation>>;
  rating?: Maybe<Rating>;
};

export type CreateOrderInput = {
  company: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  street: Scalars['String'];
  postcode: Scalars['String'];
  city: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  formular: Scalars['String'];
  frontend: Scalars['String'];
};

export type CreateOrderResult = {
  __typename: 'CreateOrderResult';
  created: Scalars['Boolean'];
  errors?: Maybe<Array<Violation>>;
};

export type CreateInfolinoFeedbackInput = {
  hotel: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  room: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  ratings: Array<InfolinoFeedbackRatingInput>;
  frontend?: Maybe<Scalars['String']>;
  paragraphId: Scalars['Int'];
};

export type InfolinoFeedbackRatingInput = {
  key: Scalars['String'];
  value: Scalars['Int'];
};

export type CreateInfolinoFeedbackResult = {
  __typename: 'CreateInfolinoFeedbackResult';
  created: Scalars['Boolean'];
  errors?: Maybe<Array<Violation>>;
};

export type CreateInfolinoWellnessInput = {
  hotel: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  room: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  date: DateInput;
  treatment: Scalars['String'];
  frontend?: Maybe<Scalars['String']>;
  paragraphId: Scalars['Int'];
};

export type CreateInfolinoWellnessResult = {
  __typename: 'CreateInfolinoWellnessResult';
  created: Scalars['Boolean'];
  errors?: Maybe<Array<Violation>>;
};

export type CreateCommentInput = {
  name?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  comment: Scalars['String'];
  privacy: Scalars['Boolean'];
  email: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  entityId: Scalars['Int'];
  parentCommentId?: Maybe<Scalars['Int']>;
  _bp?: Maybe<Scalars['String']>;
  frontend?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['Upload']>>>;
  stars?: Maybe<Scalars['Int']>;
  dateVisit?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Scalars['String']>;
  closures?: Maybe<Scalars['String']>;
  tipps?: Maybe<Scalars['String']>;
  imageCopyrights?: Maybe<Scalars['Boolean']>;
};


export type CreateCommentResult = {
  __typename: 'CreateCommentResult';
  created: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

export type FilterInput = {
  conditions?: Maybe<Array<EntityFilter>>;
  scopes?: Maybe<Array<Scope>>;
  conjunction?: Maybe<Conjunction>;
};

export type ActivityPoi = Activity | Poi;

export type EntityConnection = {
  __typename: 'EntityConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<EntityInterface>>>;
};

export type ActivityPoiConnection = {
  __typename: 'ActivityPoiConnection';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<ActivityPoi>>>;
};

export type MenuFragmentFragment = { __typename: 'Menu', name: string, items?: Maybe<Array<Maybe<{ __typename: 'MenuItem', title: string, url: string, children?: Maybe<Array<Maybe<{ __typename: 'MenuItem', title: string, url: string, children?: Maybe<Array<Maybe<{ __typename: 'MenuItem', title: string, url: string }>>> }>>> }>>> };

export type ActivityMapTeaserFragmentFragment = { __typename: 'Activity', id: number, url: string, category?: Maybe<{ __typename: 'TermCategory', key?: Maybe<string> }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }> };

export type ActivityTeaserFragmentFragment = { __typename: 'Activity', id: number, url: string, title: string, length?: Maybe<number>, duration?: Maybe<number>, body?: Maybe<string>, gpx?: Maybe<{ __typename: 'MediaGPS', url: string }>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserTextImage?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, country?: Maybe<{ __typename: 'TermCountry', name: string }>, region?: Maybe<{ __typename: 'TermRegion', name: string }>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, authors?: Maybe<Array<Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )>>>, partner?: Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )> };

export type ActivityFragmentFragment = { __typename: 'Activity', id: number, updatedAt?: Maybe<string>, url: string, title: string, body?: Maybe<string>, old_id?: Maybe<string>, duration?: Maybe<number>, length?: Maybe<number>, isOffroad?: Maybe<boolean>, elevationData?: Maybe<string>, useArticleLayout?: Maybe<boolean>, totalComments: number, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, gpx?: Maybe<{ __typename: 'MediaGPS', url: string }>, polyline?: Maybe<{ __typename: 'FieldLocation', value?: Maybe<string> }>, category?: Maybe<{ __typename: 'TermCategory', id: number, name: string, key?: Maybe<string>, labelPlural: string, frontendUrl?: Maybe<string> }>, frontends: Array<{ __typename: 'TermFrontend', name: string }>, difficulty?: Maybe<{ __typename: 'TermDifficulty', name: string }>, country?: Maybe<{ __typename: 'TermCountry', id: number, name: string }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, region?: Maybe<{ __typename: 'TermRegion', id: number, name: string }>, product?: Maybe<(
    { __typename: 'Product' }
    & ProductTeaserFragmentFragment
  )>, hotels?: Maybe<{ __typename: 'HotelConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Hotel', activities?: Maybe<Array<(
        { __typename: 'Activity' }
        & ActivityTeaserFragmentFragment
      )>> }
      & HotelTeaserFragmentFragment
    )>>> }>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, big?: Maybe<{ __typename: 'ImageDerivative', url: string }>, medium?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, small?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, hero?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserHuge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquare?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, images?: Maybe<Array<(
    { __typename: 'MediaImage', full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, big?: Maybe<{ __typename: 'ImageDerivative', url: string }>, medium?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, small?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserHuge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquare?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquareSmall?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>>, nearHotels?: Maybe<{ __typename: 'HotelConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Hotel' }
      & HotelTeaserFragmentFragment
    )>>> }>, nearActivities?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, nearPois?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    )>>> }>, productsInRegion?: Maybe<{ __typename: 'ProductConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Product' }
      & ProductTeaserFragmentFragment
    )>>> }>, activitiesInRegion?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, poisInRegion?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    )>>> }>, activityContent: Array<(
    { __typename: 'ParagraphActivityList' }
    & ParagraphActivityListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiTeaserList' }
    & ParagraphActivityPoiTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivitySlider' }
    & ParagraphActivitySliderFragmentFragment
  ) | { __typename: 'ParagraphActivityTabs' } | (
    { __typename: 'ParagraphColumns' }
    & ParagraphColumnsFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiActivitiesInRegion' }
    & ParagraphActivityPoiActivitiesInRegionFragment
  ) | (
    { __typename: 'ParagraphActivityPoiImages' }
    & ParagraphActivityPoiImagesFragment
  ) | (
    { __typename: 'ParagraphCustomTeaserList' }
    & ParagraphCustomTeaserListFragment
  ) | (
    { __typename: 'ParagraphActivityPoiMap' }
    & ParagraphActivityPoiMapFragment
  ) | { __typename: 'ParagraphActivityPoiNearHotels' } | (
    { __typename: 'ParagraphActivityPoiPoisInRegion' }
    & ParagraphActivityPoiPoisInRegionFragment
  ) | (
    { __typename: 'ParagraphActivityPoiProductsInRegion' }
    & ParagraphActivityPoiProductsInRegionFragment
  ) | (
    { __typename: 'ParagraphFormular' }
    & ParagraphFormularFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphHotelList' }
    & ParagraphHotelListFragmentFragment
  ) | { __typename: 'ParagraphHotelOffers' } | (
    { __typename: 'ParagraphImage' }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText' }
    & ParagraphImageAndTextFragmentFragment
  ) | (
    { __typename: 'ParagraphImageTextTeaser' }
    & ParagraphImageTextTeaserFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks' }
    & ParagraphLinksFragmentFragment
  ) | { __typename: 'ParagraphMerchantList' } | (
    { __typename: 'ParagraphNewsList' }
    & ParagraphNewsListFragmentFragment
  ) | (
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphRegionTeaserList' }
    & ParagraphRegionTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphText' }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphCommentListAndFormular' }
    & ParagraphCommentListAndFormularFragment
  ) | (
    { __typename: 'ParagraphActivityPoiNearActivities' }
    & ParagraphActivityPoiNearActivitiesFragment
  ) | (
    { __typename: 'ParagraphActivityPoiNearPois' }
    & ParagraphActivityPoiNearPoisFragment
  ) | { __typename: 'ParagraphPoiPassProfile' } | (
    { __typename: 'ParagraphCommentBox' }
    & ParagraphCommentBoxFragment
  ) | (
    { __typename: 'ParagraphInfoBox' }
    & ParagraphInfoBoxFragment
  ) | (
    { __typename: 'ParagraphAuthors' }
    & ParagraphAuthorsFragment
  ) | (
    { __typename: 'ParagraphPartner' }
    & ParagraphPartnerFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  ) | (
    { __typename: 'ParagraphFaq' }
    & ParagraphFaqFragment
  ) | { __typename: 'ParagraphPartnerList' }>, sidebarBlocks: Array<(
    { __typename: 'ParagraphSidebarBlock' }
    & ParagraphSidebarBlockFragment
  )>, paragraphsBetweenTextAndPhotos?: Maybe<Array<(
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  )>>, comments: Array<(
    { __typename: 'Comment' }
    & CommentFragment
  )>, authors?: Maybe<Array<Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )>>>, partner?: Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )> };

export type RatingFragmentFragment = { __typename: 'Rating', id: number, title: string, body?: Maybe<string>, reply?: Maybe<string>, ratingKindness: number, ratingHousing: number, ratingCatering: number, email?: Maybe<string>, lastname?: Maybe<string>, firstname?: Maybe<string>, publicName?: Maybe<string>, dateRange?: Maybe<{ __typename: 'FieldDate', value?: Maybe<string>, end_value?: Maybe<string> }>, hotel?: Maybe<{ __typename: 'Hotel', url: string, title: string }> };

export type HotelRatingQueryQueryVariables = Exact<{
  id: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type HotelRatingQueryQuery = { __typename: 'Query', getHotelById?: Maybe<{ __typename: 'Hotel', ratings?: Maybe<{ __typename: 'RatingConnection', total: number, items?: Maybe<Array<Maybe<(
        { __typename: 'Rating' }
        & RatingFragmentFragment
      )>>> }> }> };

export type HotelFeatureFragmentFragment = { __typename: 'TermHotelFeature', id: number, name: string, icon?: Maybe<string>, category?: Maybe<{ __typename: 'TermHotelFeatureCategory', id: number, name: string }> };

export type HotelMapTeaserFragmentFragment = { __typename: 'Hotel', id: number, url: string, category?: Maybe<{ __typename: 'TermCategory', key?: Maybe<string> }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }> };

export type HotelTeaserFragmentFragment = { __typename: 'Hotel', id: number, url: string, title: string, minPrice?: Maybe<number>, city?: Maybe<string>, averageRating?: Maybe<{ __typename: 'AverageRating', total: number, ratingCount: number }>, detailsForFrontend?: Maybe<{ __typename: 'HotelDetail', body?: Maybe<string> }>, country?: Maybe<{ __typename: 'TermCountry', name: string }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, region?: Maybe<{ __typename: 'TermRegion', name: string }>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserTextSmall?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type HotelFragmentFragment = { __typename: 'Hotel', id: number, url: string, fullUrl: string, facebookPageUrl?: Maybe<string>, onlineBookingUrl?: Maybe<string>, title: string, old_id?: Maybe<string>, beds?: Maybe<number>, email?: Maybe<string>, fax?: Maybe<string>, onlyShowOnlineBooking?: Maybe<boolean>, company?: Maybe<string>, homepage?: Maybe<string>, kns?: Maybe<string>, lastname?: Maybe<string>, city?: Maybe<string>, postcode?: Maybe<string>, stars?: Maybe<number>, street?: Maybe<string>, phone?: Maybe<string>, firstname?: Maybe<string>, maxRating?: Maybe<number>, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, activities?: Maybe<Array<(
    { __typename: 'Activity' }
    & ActivityTeaserFragmentFragment
  )>>, activitiesFreizeithotels?: Maybe<Array<(
    { __typename: 'Activity' }
    & ActivityTeaserFragmentFragment
  )>>, pois?: Maybe<Array<(
    { __typename: 'Poi' }
    & PoiTeaserFragmentFragment
  )>>, detailsForFrontend?: Maybe<{ __typename: 'HotelDetail', body?: Maybe<string>, images?: Maybe<Array<(
      { __typename: 'MediaImage', full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, big?: Maybe<{ __typename: 'ImageDerivative', url: string }>, medium?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, small?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserHuge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquare?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
      & MediaImageFragmentFragment
    )>> }>, highlightedFeaturesForFrontend?: Maybe<Array<(
    { __typename: 'TermHotelFeature' }
    & HotelFeatureFragmentFragment
  )>>, featuresForFrontend?: Maybe<Array<(
    { __typename: 'TermHotelFeature' }
    & HotelFeatureFragmentFragment
  )>>, frontends: Array<{ __typename: 'TermFrontend', name: string }>, country?: Maybe<{ __typename: 'TermCountry', id: number, name: string, isocode: string }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, region?: Maybe<{ __typename: 'TermRegion', id: number, name: string }>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', hero?: Maybe<{ __typename: 'ImageDerivative', url: string }>, full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, big?: Maybe<{ __typename: 'ImageDerivative', url: string }>, medium?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, small?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserHuge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquare?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, testimonialImage?: Maybe<(
    { __typename: 'MediaImage', big?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, rooms?: Maybe<Array<{ __typename: 'HotelRoom', roomCount?: Maybe<number>, roomType?: Maybe<{ __typename: 'TermRoomType', name: string }>, prices?: Maybe<Array<{ __typename: 'HotelRoomPrice', description?: Maybe<string>, price?: Maybe<number>, date?: Maybe<{ __typename: 'FieldDate', value?: Maybe<string>, end_value?: Maybe<string> }> }>> }>>, offersForFrontend?: Maybe<Array<(
    { __typename: 'Offers' }
    & OfferForFrontendItemFragmentFragment
  )>>, ratings?: Maybe<{ __typename: 'RatingConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Rating' }
      & RatingFragmentFragment
    )>>> }>, pushedRatings?: Maybe<{ __typename: 'RatingConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Rating' }
      & RatingFragmentFragment
    )>>> }>, nearActivities?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, nearPois?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    )>>> }>, averageRating?: Maybe<{ __typename: 'AverageRating', ratingCount: number, total: number, catering: number, housing: number, kindness: number }>, activitiesInRegion?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, productsInRegion?: Maybe<{ __typename: 'ProductConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Product' }
      & ProductTeaserFragmentFragment
    )>>> }>, poisInRegion?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    )>>> }> };

export type MerchantTeaserFragmentFragment = { __typename: 'Merchant', id: number, title: string, street: string, city?: Maybe<string>, postcode?: Maybe<string>, email?: Maybe<string>, phone?: Maybe<string>, homepage?: Maybe<string>, company: string, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }> };

export type NewsFragmentFragment = { __typename: 'News', id: number, title: string, created?: Maybe<string>, updatedAt?: Maybe<string>, url: string, frontend?: Maybe<{ __typename: 'TermFrontend', name: string }>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, hero?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, content?: Maybe<Array<(
    { __typename: 'ParagraphHotelOffers', id: number }
    & ParagraphHotelOffersFragmentFragment
  ) | (
    { __typename: 'ParagraphActivitySlider', id: number }
    & ParagraphActivitySliderFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiTeaserList', id: number }
    & ParagraphActivityPoiTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphHero', id: number }
    & ParagraphHeroFragmentFragment
  ) | (
    { __typename: 'ParagraphText', id: number }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityList', id: number }
    & ParagraphActivityListFragmentFragment
  ) | (
    { __typename: 'ParagraphHotelList', id: number }
    & ParagraphHotelListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityTabs', id: number }
    & ParagraphActivityTabsFragmentFragment
  ) | (
    { __typename: 'ParagraphFormular', id: number }
    & ParagraphFormularFragmentFragment
  ) | (
    { __typename: 'ParagraphRegionTeaserList', id: number }
    & ParagraphRegionTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphMerchantList', id: number }
    & ParagraphMerchantListFragmentFragment
  ) | (
    { __typename: 'ParagraphColumns', id: number }
    & ParagraphColumnsFragmentFragment
  ) | (
    { __typename: 'ParagraphContainer', id: number }
    & ParagraphContainerFragmentFragment
  ) | (
    { __typename: 'ParagraphSearchbar', id: number }
    & ParagraphSearchbarFragmentFragment
  ) | { __typename: 'ParagraphNewsletter', id: number } | (
    { __typename: 'ParagraphHeader', id: number }
    & ParagraphHeaderFragmentFragment
  ) | (
    { __typename: 'ParagraphTestimonial', id: number }
    & ParagraphTestimonialFragmentFragment
  ) | (
    { __typename: 'ParagraphSearchResults', id: number }
    & ParagraphSearchResultsFragmentFragment
  ) | (
    { __typename: 'ParagraphImage', id: number }
    & ParagraphImageFragmentFragment
  ) | { __typename: 'ParagraphNewsList', id: number } | (
    { __typename: 'ParagraphImageAndText', id: number }
    & ParagraphImageAndTextFragmentFragment
  ) | (
    { __typename: 'ParagraphCustomTeaserList', id: number }
    & ParagraphCustomTeaserListFragment
  ) | (
    { __typename: 'ParagraphProductList', id: number }
    & ParagraphProductListFragmentFragment
  ) | { __typename: 'ParagraphEyeCatcher', id: number } | (
    { __typename: 'ParagraphLinks', id: number }
    & ParagraphLinksFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary', id: number }
    & ParagraphFromLibraryFragment
  ) | { __typename: 'ParagraphPassTable', id: number } | { __typename: 'ParagraphPassMap', id: number } | { __typename: 'ParagraphPassListMap', id: number } | { __typename: 'ParagraphSearchById', id: number } | (
    { __typename: 'ParagraphCommentBox', id: number }
    & ParagraphCommentBoxFragment
  ) | (
    { __typename: 'ParagraphInfoBox', id: number }
    & ParagraphInfoBoxFragment
  ) | (
    { __typename: 'ParagraphAuthors', id: number }
    & ParagraphAuthorsFragment
  ) | (
    { __typename: 'ParagraphPartner', id: number }
    & ParagraphPartnerFragment
  ) | (
    { __typename: 'ParagraphAdSlot', id: number }
    & ParagraphAdSlotFragment
  ) | (
    { __typename: 'ParagraphFaq', id: number }
    & ParagraphFaqFragment
  ) | { __typename: 'ParagraphPartnerList', id: number }>>, authors?: Maybe<Array<Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )>>>, partner?: Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )> };

export type NewsTeaserFragmentFragment = { __typename: 'News', id: number, title: string, created?: Maybe<string>, url: string, teaserText?: Maybe<string>, frontend?: Maybe<{ __typename: 'TermFrontend', name: string }>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, hero?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type PageFragmentFragment = { __typename: 'Page', id: number, title: string, updatedAt?: Maybe<string>, url: string, showTitle?: Maybe<boolean>, isGroupSearch?: Maybe<boolean>, frontend?: Maybe<{ __typename: 'TermFrontend', name: string }>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, authors?: Maybe<Array<Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )>>>, partner?: Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )>, content?: Maybe<Array<(
    { __typename: 'ParagraphHotelOffers', id: number }
    & ParagraphHotelOffersFragmentFragment
  ) | (
    { __typename: 'ParagraphActivitySlider', id: number }
    & ParagraphActivitySliderFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiTeaserList', id: number }
    & ParagraphActivityPoiTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphHero', id: number }
    & ParagraphHeroFragmentFragment
  ) | (
    { __typename: 'ParagraphText', id: number }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityList', id: number }
    & ParagraphActivityListFragmentFragment
  ) | (
    { __typename: 'ParagraphHotelList', id: number }
    & ParagraphHotelListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityTabs', id: number }
    & ParagraphActivityTabsFragmentFragment
  ) | (
    { __typename: 'ParagraphFormular', id: number }
    & ParagraphFormularFragmentFragment
  ) | (
    { __typename: 'ParagraphRegionTeaserList', id: number }
    & ParagraphRegionTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphMerchantList', id: number }
    & ParagraphMerchantListFragmentFragment
  ) | (
    { __typename: 'ParagraphColumns', id: number }
    & ParagraphColumnsFragmentFragment
  ) | (
    { __typename: 'ParagraphContainer', id: number }
    & ParagraphContainerFragmentFragment
  ) | (
    { __typename: 'ParagraphSearchbar', id: number }
    & ParagraphSearchbarFragmentFragment
  ) | { __typename: 'ParagraphNewsletter', id: number } | (
    { __typename: 'ParagraphHeader', id: number }
    & ParagraphHeaderFragmentFragment
  ) | (
    { __typename: 'ParagraphTestimonial', id: number }
    & ParagraphTestimonialFragmentFragment
  ) | (
    { __typename: 'ParagraphSearchResults', id: number }
    & ParagraphSearchResultsFragmentFragment
  ) | (
    { __typename: 'ParagraphImage', id: number }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphNewsList', id: number }
    & ParagraphNewsListFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText', id: number }
    & ParagraphImageAndTextFragmentFragment
  ) | (
    { __typename: 'ParagraphCustomTeaserList', id: number }
    & ParagraphCustomTeaserListFragment
  ) | (
    { __typename: 'ParagraphProductList', id: number }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphEyeCatcher', id: number }
    & ParagraphEyeCatcherFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks', id: number }
    & ParagraphLinksFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary', id: number }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphPassTable', id: number }
    & ParagraphPassTableFragment
  ) | (
    { __typename: 'ParagraphPassMap', id: number }
    & ParagraphPassMapFragment
  ) | (
    { __typename: 'ParagraphPassListMap', id: number }
    & ParagraphPassListMapFragment
  ) | (
    { __typename: 'ParagraphSearchById', id: number }
    & ParagraphSearchByIdFragment
  ) | (
    { __typename: 'ParagraphCommentBox', id: number }
    & ParagraphCommentBoxFragment
  ) | (
    { __typename: 'ParagraphInfoBox', id: number }
    & ParagraphInfoBoxFragment
  ) | (
    { __typename: 'ParagraphAuthors', id: number }
    & ParagraphAuthorsFragment
  ) | (
    { __typename: 'ParagraphPartner', id: number }
    & ParagraphPartnerFragment
  ) | (
    { __typename: 'ParagraphAdSlot', id: number }
    & ParagraphAdSlotFragment
  ) | (
    { __typename: 'ParagraphFaq', id: number }
    & ParagraphFaqFragment
  ) | { __typename: 'ParagraphPartnerList', id: number }>> };

export type PersonTeaserFragmentFragment = { __typename: 'Person', id: number, title: string, url: string, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type PersonFragmentFragment = { __typename: 'Person', id: number, title: string, homepageUrl?: Maybe<string>, job?: Maybe<string>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, personContent: Array<{ __typename: 'ParagraphSidebarBlock', id: number } | { __typename: 'ParagraphActivityPoiNearHotels', id: number } | { __typename: 'ParagraphCustomTeaserList', id: number } | { __typename: 'ParagraphCustomTeaserListItem', id: number } | { __typename: 'ParagraphImageTextTeaser', id: number } | (
    { __typename: 'ParagraphLinks', id: number }
    & ParagraphLinksFragmentFragment
  ) | { __typename: 'ParagraphLink', id: number } | (
    { __typename: 'ParagraphText', id: number }
    & ParagraphTextFragmentFragment
  ) | { __typename: 'ParagraphAdSlot', id: number } | { __typename: 'ParagraphActivityList', id: number } | { __typename: 'ParagraphActivityPoiTeaserList', id: number } | { __typename: 'ParagraphActivityPoiTeaser', id: number } | { __typename: 'ParagraphActivitySlider', id: number } | { __typename: 'ParagraphActivityTabs', id: number } | { __typename: 'ParagraphSearchCategory', id: number } | (
    { __typename: 'ParagraphColumns', id: number }
    & ParagraphColumnsFragmentFragment
  ) | { __typename: 'ParagraphColumn', id: number } | (
    { __typename: 'ParagraphImage', id: number }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText', id: number }
    & ParagraphImageAndTextFragmentFragment
  ) | { __typename: 'ParagraphAuthors', id: number } | { __typename: 'ParagraphPartner', id: number } | { __typename: 'ParagraphPartnerList', id: number } | { __typename: 'ParagraphActivityPoiActivitiesInRegion', id: number } | { __typename: 'ParagraphActivityPoiImages', id: number } | { __typename: 'ParagraphActivityPoiMap', id: number } | { __typename: 'ParagraphActivityPoiPoisInRegion', id: number } | { __typename: 'ParagraphActivityPoiProductsInRegion', id: number } | { __typename: 'ParagraphFormular', id: number } | { __typename: 'ParagraphFromLibrary', id: number } | { __typename: 'ParagraphHotelList', id: number } | { __typename: 'ParagraphHotelOffers', id: number } | { __typename: 'ParagraphMerchantList', id: number } | { __typename: 'ParagraphNewsList', id: number } | { __typename: 'ParagraphHero', id: number } | { __typename: 'ParagraphRegionTeaserList', id: number } | { __typename: 'ParagraphRegionTeaserListItem', id: number } | { __typename: 'ParagraphContainer', id: number } | { __typename: 'ParagraphCommentListAndFormular', id: number } | { __typename: 'ParagraphSearchById', id: number } | { __typename: 'ParagraphCommentBox', id: number } | { __typename: 'ParagraphInfoBox', id: number } | { __typename: 'ParagraphFaq', id: number } | { __typename: 'ParagraphFaqItem', id: number } | { __typename: 'ParagraphSearchbar', id: number } | { __typename: 'ParagraphNewsletter', id: number } | { __typename: 'ParagraphHeader', id: number } | { __typename: 'ParagraphTestimonial', id: number } | { __typename: 'ParagraphSearchResults', id: number } | { __typename: 'ParagraphProductList', id: number } | { __typename: 'ParagraphEyeCatcher', id: number } | { __typename: 'ParagraphPassTable', id: number } | { __typename: 'ParagraphPassMap', id: number } | { __typename: 'ParagraphPassListMap', id: number } | { __typename: 'ParagraphActivityPoiNearActivities', id: number } | { __typename: 'ParagraphActivityPoiNearPois', id: number } | { __typename: 'ParagraphPoiPassProfile', id: number } | { __typename: 'ParagraphSpacer', id: number } | { __typename: 'ParagraphInfolinoActivities', id: number } | { __typename: 'ParagraphInfolinoContact', id: number } | { __typename: 'ParagraphInfolinoRating', id: number } | { __typename: 'ParagraphInfolinoPOIs', id: number } | { __typename: 'ParagraphInfolinoWellnessFormular', id: number } | { __typename: 'ParagraphInfolinoFeedbackFormular', id: number }> };

export type PoiTableFragment = { __typename: 'Poi', id: number, url: string, title: string, isPass?: Maybe<boolean>, passHeight?: Maybe<number>, toll?: Maybe<boolean>, tollPrices?: Maybe<string>, unpaved?: Maybe<boolean>, length?: Maybe<number>, country?: Maybe<{ __typename: 'TermCountry', id: number, name: string, isocode: string }>, region?: Maybe<{ __typename: 'TermRegion', id: number, name: string }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, category?: Maybe<{ __typename: 'TermCategory', key?: Maybe<string> }>, gpx?: Maybe<{ __typename: 'MediaGPS', url: string }> };

export type PoiMapTeaserFragmentFragment = { __typename: 'Poi', id: number, url: string, isPass?: Maybe<boolean>, category?: Maybe<{ __typename: 'TermCategory', key?: Maybe<string> }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, gpx?: Maybe<{ __typename: 'MediaGPS', url: string }> };

export type PoiTeaserFragmentFragment = { __typename: 'Poi', id: number, url: string, title: string, isPass?: Maybe<boolean>, passHeight?: Maybe<number>, body?: Maybe<string>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserTextImage?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, country?: Maybe<{ __typename: 'TermCountry', name: string }>, region?: Maybe<{ __typename: 'TermRegion', name: string }>, category?: Maybe<{ __typename: 'TermCategory', id: number, name: string, key?: Maybe<string> }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, authors?: Maybe<Array<Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )>>>, partner?: Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )> };

export type PoiFragmentFragment = { __typename: 'Poi', id: number, url: string, updatedAt?: Maybe<string>, title: string, body?: Maybe<string>, old_id?: Maybe<string>, isPass?: Maybe<boolean>, isOffroad?: Maybe<boolean>, duration?: Maybe<number>, length?: Maybe<number>, passHeight?: Maybe<number>, maxSlope?: Maybe<number>, winterClosure?: Maybe<string>, basePlaces?: Maybe<string>, toll?: Maybe<boolean>, tollPrices?: Maybe<string>, unpaved?: Maybe<boolean>, numberOfTurns?: Maybe<number>, deadEnd?: Maybe<boolean>, restrictions?: Maybe<string>, elevationData?: Maybe<string>, stars?: Maybe<number>, useArticleLayout?: Maybe<boolean>, totalComments: number, offroadCars?: Maybe<Array<Maybe<string>>>, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, gpx?: Maybe<{ __typename: 'MediaGPS', url: string }>, category?: Maybe<{ __typename: 'TermCategory', name: string, key?: Maybe<string> }>, frontends: Array<{ __typename: 'TermFrontend', name: string }>, difficulty?: Maybe<{ __typename: 'TermDifficulty', name: string }>, country?: Maybe<{ __typename: 'TermCountry', name: string }>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, region?: Maybe<{ __typename: 'TermRegion', name: string }>, hotels?: Maybe<{ __typename: 'HotelConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Hotel' }
      & HotelTeaserFragmentFragment
    )>>> }>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', hero?: Maybe<{ __typename: 'ImageDerivative', url: string }>, full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, big?: Maybe<{ __typename: 'ImageDerivative', url: string }>, medium?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, small?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, images?: Maybe<Array<(
    { __typename: 'MediaImage', full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, big?: Maybe<{ __typename: 'ImageDerivative', url: string }>, medium?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, small?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserHuge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquare?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquareSmall?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>>, nearHotels?: Maybe<{ __typename: 'HotelConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Hotel' }
      & HotelTeaserFragmentFragment
    )>>> }>, nearActivities?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, nearPois?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    )>>> }>, productsInRegion?: Maybe<{ __typename: 'ProductConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Product' }
      & ProductFragmentFragment
    )>>> }>, activitiesInRegion?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, poisInRegion?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    )>>> }>, poiContent: Array<(
    { __typename: 'ParagraphActivityList' }
    & ParagraphActivityListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiTeaserList' }
    & ParagraphActivityPoiTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivitySlider' }
    & ParagraphActivitySliderFragmentFragment
  ) | { __typename: 'ParagraphActivityTabs' } | (
    { __typename: 'ParagraphColumns' }
    & ParagraphColumnsFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiActivitiesInRegion' }
    & ParagraphActivityPoiActivitiesInRegionFragment
  ) | (
    { __typename: 'ParagraphActivityPoiImages' }
    & ParagraphActivityPoiImagesFragment
  ) | (
    { __typename: 'ParagraphCustomTeaserList' }
    & ParagraphCustomTeaserListFragment
  ) | (
    { __typename: 'ParagraphActivityPoiMap' }
    & ParagraphActivityPoiMapFragment
  ) | { __typename: 'ParagraphActivityPoiNearHotels' } | (
    { __typename: 'ParagraphActivityPoiPoisInRegion' }
    & ParagraphActivityPoiPoisInRegionFragment
  ) | (
    { __typename: 'ParagraphActivityPoiProductsInRegion' }
    & ParagraphActivityPoiProductsInRegionFragment
  ) | (
    { __typename: 'ParagraphFormular' }
    & ParagraphFormularFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphHotelList' }
    & ParagraphHotelListFragmentFragment
  ) | { __typename: 'ParagraphHotelOffers' } | (
    { __typename: 'ParagraphImage' }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText' }
    & ParagraphImageAndTextFragmentFragment
  ) | (
    { __typename: 'ParagraphImageTextTeaser' }
    & ParagraphImageTextTeaserFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks' }
    & ParagraphLinksFragmentFragment
  ) | { __typename: 'ParagraphMerchantList' } | (
    { __typename: 'ParagraphNewsList' }
    & ParagraphNewsListFragmentFragment
  ) | (
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphRegionTeaserList' }
    & ParagraphRegionTeaserListFragmentFragment
  ) | (
    { __typename: 'ParagraphText' }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphCommentListAndFormular' }
    & ParagraphCommentListAndFormularFragment
  ) | (
    { __typename: 'ParagraphActivityPoiNearActivities' }
    & ParagraphActivityPoiNearActivitiesFragment
  ) | (
    { __typename: 'ParagraphActivityPoiNearPois' }
    & ParagraphActivityPoiNearPoisFragment
  ) | (
    { __typename: 'ParagraphPoiPassProfile' }
    & ParagraphPoiPassProfileFragment
  ) | (
    { __typename: 'ParagraphCommentBox' }
    & ParagraphCommentBoxFragment
  ) | (
    { __typename: 'ParagraphInfoBox' }
    & ParagraphInfoBoxFragment
  ) | (
    { __typename: 'ParagraphAuthors' }
    & ParagraphAuthorsFragment
  ) | (
    { __typename: 'ParagraphPartner' }
    & ParagraphPartnerFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  ) | (
    { __typename: 'ParagraphFaq' }
    & ParagraphFaqFragment
  ) | { __typename: 'ParagraphPartnerList' }>, sidebarBlocks: Array<(
    { __typename: 'ParagraphSidebarBlock' }
    & ParagraphSidebarBlockFragment
  )>, passParagraphsBetweenTextAndPhotos?: Maybe<Array<(
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  )>>, offroadParagraphsBetweenTextAndPhotos?: Maybe<Array<(
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  )>>, comments: Array<(
    { __typename: 'Comment' }
    & CommentFragment
  )>, authors?: Maybe<Array<Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )>>>, partner?: Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )> };

export type ProductDownloadQueryQueryVariables = Exact<{
  id: Scalars['Int'];
  password?: Maybe<Scalars['String']>;
}>;


export type ProductDownloadQueryQuery = { __typename: 'Query', getProductDownload?: Maybe<{ __typename: 'ProductDownloadResult', link?: Maybe<string>, error?: Maybe<string> }> };

export type ProductTeaserFragmentFragment = { __typename: 'Product', id: number, title: string, url: string, isbn?: Maybe<string>, downloadText?: Maybe<string>, downloadPassword?: Maybe<string>, externalLink?: Maybe<string>, subtitle?: Maybe<string>, price?: Maybe<number>, body?: Maybe<string>, productCategory: { __typename: 'TermProductCategory', id: number, name: string }, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, hero?: Maybe<{ __typename: 'ImageDerivative', url: string }>, productImage?: Maybe<{ __typename: 'ImageDerivative', url: string, width?: Maybe<number>, height?: Maybe<number> }> }
    & MediaImageFragmentFragment
  )> };

export type ProductFragmentFragment = { __typename: 'Product', id: number, title: string, url: string, isbn?: Maybe<string>, downloadText?: Maybe<string>, downloadPassword?: Maybe<string>, externalLink?: Maybe<string>, subtitle?: Maybe<string>, price?: Maybe<number>, body?: Maybe<string>, gpxFiles?: Maybe<Array<{ __typename: 'MediaGPS', url: string }>>, images?: Maybe<Array<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, hero?: Maybe<{ __typename: 'ImageDerivative', url: string }>, full?: Maybe<{ __typename: 'ImageDerivative', url: string }>, tiny?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserHuge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserSquare?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>>, productCategory: { __typename: 'TermProductCategory', id: number, name: string }, metatags?: Maybe<Array<Maybe<(
    { __typename: 'Metatag' }
    & MetaTagsFragmentFragment
  )>>>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }>, hero?: Maybe<{ __typename: 'ImageDerivative', url: string }>, productImage?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, productContent: Array<{ __typename: 'ParagraphSidebarBlock' } | { __typename: 'ParagraphActivityPoiNearHotels' } | { __typename: 'ParagraphCustomTeaserList' } | { __typename: 'ParagraphCustomTeaserListItem' } | (
    { __typename: 'ParagraphImageTextTeaser' }
    & ParagraphImageTextTeaserFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks' }
    & ParagraphLinksFragmentFragment
  ) | { __typename: 'ParagraphLink' } | (
    { __typename: 'ParagraphText' }
    & ParagraphTextFragmentFragment
  ) | { __typename: 'ParagraphAdSlot' } | (
    { __typename: 'ParagraphActivityList' }
    & ParagraphActivityListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiTeaserList' }
    & ParagraphActivityPoiTeaserListFragmentFragment
  ) | { __typename: 'ParagraphActivityPoiTeaser' } | { __typename: 'ParagraphActivitySlider' } | { __typename: 'ParagraphActivityTabs' } | { __typename: 'ParagraphSearchCategory' } | (
    { __typename: 'ParagraphColumns' }
    & ParagraphColumnsFragmentFragment
  ) | { __typename: 'ParagraphColumn' } | (
    { __typename: 'ParagraphImage' }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText' }
    & ParagraphImageAndTextFragmentFragment
  ) | { __typename: 'ParagraphAuthors' } | { __typename: 'ParagraphPartner' } | { __typename: 'ParagraphPartnerList' } | { __typename: 'ParagraphActivityPoiActivitiesInRegion' } | { __typename: 'ParagraphActivityPoiImages' } | { __typename: 'ParagraphActivityPoiMap' } | { __typename: 'ParagraphActivityPoiPoisInRegion' } | { __typename: 'ParagraphActivityPoiProductsInRegion' } | { __typename: 'ParagraphFormular' } | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphHotelList' }
    & ParagraphHotelListFragmentFragment
  ) | { __typename: 'ParagraphHotelOffers' } | { __typename: 'ParagraphMerchantList' } | (
    { __typename: 'ParagraphNewsList' }
    & ParagraphNewsListFragmentFragment
  ) | { __typename: 'ParagraphHero' } | { __typename: 'ParagraphRegionTeaserList' } | { __typename: 'ParagraphRegionTeaserListItem' } | { __typename: 'ParagraphContainer' } | { __typename: 'ParagraphCommentListAndFormular' } | { __typename: 'ParagraphSearchById' } | { __typename: 'ParagraphCommentBox' } | { __typename: 'ParagraphInfoBox' } | { __typename: 'ParagraphFaq' } | { __typename: 'ParagraphFaqItem' } | { __typename: 'ParagraphSearchbar' } | { __typename: 'ParagraphNewsletter' } | { __typename: 'ParagraphHeader' } | { __typename: 'ParagraphTestimonial' } | { __typename: 'ParagraphSearchResults' } | (
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | { __typename: 'ParagraphEyeCatcher' } | { __typename: 'ParagraphPassTable' } | { __typename: 'ParagraphPassMap' } | { __typename: 'ParagraphPassListMap' } | { __typename: 'ParagraphActivityPoiNearActivities' } | { __typename: 'ParagraphActivityPoiNearPois' } | { __typename: 'ParagraphPoiPassProfile' } | { __typename: 'ParagraphSpacer' } | { __typename: 'ParagraphInfolinoActivities' } | { __typename: 'ParagraphInfolinoContact' } | { __typename: 'ParagraphInfolinoRating' } | { __typename: 'ParagraphInfolinoPOIs' } | { __typename: 'ParagraphInfolinoWellnessFormular' } | { __typename: 'ParagraphInfolinoFeedbackFormular' }>, productsInRegion?: Maybe<{ __typename: 'ProductConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Product' }
      & ProductTeaserFragmentFragment
    )>>> }> };

export type ParagraphActivityListFragmentFragment = { __typename: 'ParagraphActivityList', id: number, title?: Maybe<string>, subtitle?: Maybe<string>, limit: number, linktext?: Maybe<string>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, data?: Maybe<{ __typename: 'ActivityConnection', items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }>, regions?: Maybe<Array<{ __typename: 'TermRegion', id: number }>>, countries?: Maybe<Array<{ __typename: 'TermCountry', id: number }>> };

export type ParagraphActivityPoiActivitiesInRegionFragment = { __typename: 'ParagraphActivityPoiActivitiesInRegion', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiImagesFragment = { __typename: 'ParagraphActivityPoiImages', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiMapFragment = { __typename: 'ParagraphActivityPoiMap', id: number };

export type ParagraphActivityPoiNearActivitiesFragment = { __typename: 'ParagraphActivityPoiNearActivities', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiNearHotelsFragment = { __typename: 'ParagraphActivityPoiNearHotels', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiNearPoisFragment = { __typename: 'ParagraphActivityPoiNearPois', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiPoisInRegionFragment = { __typename: 'ParagraphActivityPoiPoisInRegion', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiProductsInRegionFragment = { __typename: 'ParagraphActivityPoiProductsInRegion', id: number, title?: Maybe<string> };

export type ParagraphActivityPoiTeaserListFragmentFragment = { __typename: 'ParagraphActivityPoiTeaserList', id: number, title?: Maybe<string>, subtitle?: Maybe<string>, teaser?: Maybe<Array<{ __typename: 'ParagraphActivityPoiTeaser', id: number, title?: Maybe<string>, termReference?: Maybe<{ __typename: 'TermCategory', id: number, name: string, frontendUrl?: Maybe<string>, key?: Maybe<string>, image?: Maybe<(
        { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
        & MediaImageFragmentFragment
      )> }> }>> };

export type ParagraphActivitySliderFragmentFragment = { __typename: 'ParagraphActivitySlider', id: number, title?: Maybe<string>, subtitle?: Maybe<string>, data?: Maybe<{ __typename: 'ActivityConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )>>> }> };

export type ParagraphActivityTabsFragmentFragment = { __typename: 'ParagraphActivityTabs', id: number, title?: Maybe<string>, subtitle?: Maybe<string>, limitPerCategory: number, categories: Array<{ __typename: 'ParagraphSearchCategory', title?: Maybe<string>, category?: Maybe<(
      { __typename: 'TermCategory' }
      & TermCategoryFragmentFragment
    )> }>, categoryItems?: Maybe<Array<{ __typename: 'ParagraphActivityTabData', category?: Maybe<(
      { __typename: 'TermCategory' }
      & TermCategoryFragmentFragment
    )>, items: Array<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    )> }>> };

export type ParagraphAdSlotFragment = { __typename: 'ParagraphAdSlot', id: number, slot: (
    { __typename: 'TermAdSlot' }
    & AdSlotFragment
  ) };

export type ParagraphAuthorsFragment = { __typename: 'ParagraphAuthors', id: number };

export type ParagraphColumnFragmentFragment = { __typename: 'ParagraphColumn', content: Array<(
    { __typename: 'ParagraphText', id: number }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphImageTextTeaser', id: number }
    & ParagraphImageTextTeaserFragmentFragment
  ) | (
    { __typename: 'ParagraphImage', id: number }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText', id: number }
    & ParagraphImageAndTextFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks', id: number }
    & ParagraphLinksFragmentFragment
  ) | (
    { __typename: 'ParagraphAuthors', id: number }
    & ParagraphAuthorsFragment
  ) | (
    { __typename: 'ParagraphPartner', id: number }
    & ParagraphPartnerFragment
  ) | (
    { __typename: 'ParagraphAdSlot', id: number }
    & ParagraphAdSlotFragment
  ) | { __typename: 'ParagraphPartnerList', id: number }> };

export type ParagraphColumnsFragmentFragment = { __typename: 'ParagraphColumns', content: Array<(
    { __typename: 'ParagraphColumn', id: number }
    & ParagraphColumnFragmentFragment
  )> };

export type ParagraphCommentBoxFragment = { __typename: 'ParagraphCommentBox', externalAuthor?: Maybe<string>, customLink?: Maybe<string>, text: string, title?: Maybe<string>, author?: Maybe<(
    { __typename: 'Person' }
    & PersonTeaserFragmentFragment
  )> };

export type ParagraphCommentListAndFormularFragment = { __typename: 'ParagraphCommentListAndFormular', id: number, headline?: Maybe<string>, totalComments: number, comments: Array<(
    { __typename: 'Comment' }
    & CommentFragment
  )> };

export type ParagraphContainerFragmentFragment = { __typename: 'ParagraphContainer', size: string, content: Array<(
    { __typename: 'ParagraphText', id: number }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphColumns', id: number }
    & ParagraphColumnsFragmentFragment
  ) | (
    { __typename: 'ParagraphImage', id: number }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText', id: number }
    & ParagraphImageAndTextFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks', id: number }
    & ParagraphLinksFragmentFragment
  ) | (
    { __typename: 'ParagraphFromLibrary', id: number }
    & ParagraphFromLibraryFragment
  ) | (
    { __typename: 'ParagraphCommentListAndFormular', id: number }
    & ParagraphCommentListAndFormularFragment
  ) | (
    { __typename: 'ParagraphSearchById', id: number }
    & ParagraphSearchByIdFragment
  ) | (
    { __typename: 'ParagraphCommentBox', id: number }
    & ParagraphCommentBoxFragment
  ) | (
    { __typename: 'ParagraphInfoBox', id: number }
    & ParagraphInfoBoxFragment
  ) | (
    { __typename: 'ParagraphAuthors', id: number }
    & ParagraphAuthorsFragment
  ) | (
    { __typename: 'ParagraphPartner', id: number }
    & ParagraphPartnerFragment
  ) | (
    { __typename: 'ParagraphAdSlot', id: number }
    & ParagraphAdSlotFragment
  ) | (
    { __typename: 'ParagraphFaq', id: number }
    & ParagraphFaqFragment
  ) | { __typename: 'ParagraphPartnerList', id: number }> };

export type ParagraphCustomTeaserListItemFragment = { __typename: 'ParagraphCustomTeaserListItem', title: string, body: string, linkText?: Maybe<string>, linkUrl: string, image: (
    { __typename: 'MediaImage', teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  ) };

export type ParagraphCustomTeaserListFragment = { __typename: 'ParagraphCustomTeaserList', id: number, items?: Maybe<Array<Maybe<(
    { __typename: 'ParagraphCustomTeaserListItem' }
    & ParagraphCustomTeaserListItemFragment
  )>>> };

export type ParagraphEyeCatcherFragmentFragment = { __typename: 'ParagraphEyeCatcher', id: number, headline?: Maybe<string>, body?: Maybe<string>, alignment?: Maybe<string>, linkText?: Maybe<string>, linkUrl?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', big?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, contentImage?: Maybe<(
    { __typename: 'MediaImage', inline?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type ParagraphFaqFragment = { __typename: 'ParagraphFaq', id: number, title?: Maybe<string>, hideFrontend?: Maybe<boolean>, questions?: Maybe<Array<Maybe<{ __typename: 'ParagraphFaqItem', question?: Maybe<string>, answer?: Maybe<string> }>>> };

export type ParagraphFormularFragmentFragment = { __typename: 'ParagraphFormular', id: number, formular: string, textConfirm: string, textError: string };

export type ParagraphFromLibraryItemFragment = { __typename: 'ParagraphFromLibraryItem', id: number, content: Array<{ __typename: 'ParagraphSidebarBlock' } | { __typename: 'ParagraphActivityPoiNearHotels' } | { __typename: 'ParagraphCustomTeaserList' } | { __typename: 'ParagraphCustomTeaserListItem' } | (
    { __typename: 'ParagraphImageTextTeaser' }
    & ParagraphImageTextTeaserFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks' }
    & ParagraphLinksFragmentFragment
  ) | { __typename: 'ParagraphLink' } | (
    { __typename: 'ParagraphText' }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  ) | (
    { __typename: 'ParagraphActivityList' }
    & ParagraphActivityListFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityPoiTeaserList' }
    & ParagraphActivityPoiTeaserListFragmentFragment
  ) | { __typename: 'ParagraphActivityPoiTeaser' } | (
    { __typename: 'ParagraphActivitySlider' }
    & ParagraphActivitySliderFragmentFragment
  ) | (
    { __typename: 'ParagraphActivityTabs' }
    & ParagraphActivityTabsFragmentFragment
  ) | { __typename: 'ParagraphSearchCategory' } | (
    { __typename: 'ParagraphColumns' }
    & ParagraphColumnsFragmentFragment
  ) | { __typename: 'ParagraphColumn' } | (
    { __typename: 'ParagraphImage' }
    & ParagraphImageFragmentFragment
  ) | (
    { __typename: 'ParagraphImageAndText' }
    & ParagraphImageAndTextFragmentFragment
  ) | { __typename: 'ParagraphAuthors' } | { __typename: 'ParagraphPartner' } | { __typename: 'ParagraphPartnerList' } | (
    { __typename: 'ParagraphActivityPoiActivitiesInRegion' }
    & ParagraphActivityPoiActivitiesInRegionFragment
  ) | (
    { __typename: 'ParagraphActivityPoiImages' }
    & ParagraphActivityPoiImagesFragment
  ) | (
    { __typename: 'ParagraphActivityPoiMap' }
    & ParagraphActivityPoiMapFragment
  ) | (
    { __typename: 'ParagraphActivityPoiPoisInRegion' }
    & ParagraphActivityPoiPoisInRegionFragment
  ) | (
    { __typename: 'ParagraphActivityPoiProductsInRegion' }
    & ParagraphActivityPoiProductsInRegionFragment
  ) | (
    { __typename: 'ParagraphFormular' }
    & ParagraphFormularFragmentFragment
  ) | { __typename: 'ParagraphFromLibrary' } | (
    { __typename: 'ParagraphHotelList' }
    & ParagraphHotelListFragmentFragment
  ) | (
    { __typename: 'ParagraphHotelOffers' }
    & ParagraphHotelOffersFragmentFragment
  ) | (
    { __typename: 'ParagraphMerchantList' }
    & ParagraphMerchantListFragmentFragment
  ) | (
    { __typename: 'ParagraphNewsList' }
    & ParagraphNewsListFragmentFragment
  ) | (
    { __typename: 'ParagraphHero' }
    & ParagraphHeroFragmentFragment
  ) | (
    { __typename: 'ParagraphRegionTeaserList' }
    & ParagraphRegionTeaserListFragmentFragment
  ) | { __typename: 'ParagraphRegionTeaserListItem' } | { __typename: 'ParagraphContainer' } | (
    { __typename: 'ParagraphCommentListAndFormular' }
    & ParagraphCommentListAndFormularFragment
  ) | { __typename: 'ParagraphSearchById' } | { __typename: 'ParagraphCommentBox' } | { __typename: 'ParagraphInfoBox' } | { __typename: 'ParagraphFaq' } | { __typename: 'ParagraphFaqItem' } | (
    { __typename: 'ParagraphSearchbar' }
    & ParagraphSearchbarFragmentFragment
  ) | { __typename: 'ParagraphNewsletter' } | { __typename: 'ParagraphHeader' } | (
    { __typename: 'ParagraphTestimonial' }
    & ParagraphTestimonialFragmentFragment
  ) | { __typename: 'ParagraphSearchResults' } | (
    { __typename: 'ParagraphProductList' }
    & ParagraphProductListFragmentFragment
  ) | (
    { __typename: 'ParagraphEyeCatcher' }
    & ParagraphEyeCatcherFragmentFragment
  ) | { __typename: 'ParagraphPassTable' } | { __typename: 'ParagraphPassMap' } | { __typename: 'ParagraphPassListMap' } | { __typename: 'ParagraphActivityPoiNearActivities' } | { __typename: 'ParagraphActivityPoiNearPois' } | { __typename: 'ParagraphPoiPassProfile' } | { __typename: 'ParagraphSpacer' } | { __typename: 'ParagraphInfolinoActivities' } | { __typename: 'ParagraphInfolinoContact' } | { __typename: 'ParagraphInfolinoRating' } | { __typename: 'ParagraphInfolinoPOIs' } | { __typename: 'ParagraphInfolinoWellnessFormular' } | { __typename: 'ParagraphInfolinoFeedbackFormular' }> };

export type ParagraphFromLibraryFragment = { __typename: 'ParagraphFromLibrary', id: number, paragraph: (
    { __typename: 'ParagraphFromLibraryItem' }
    & ParagraphFromLibraryItemFragment
  ) };

export type ParagraphHeaderFragmentFragment = { __typename: 'ParagraphHeader', useNegativeLogoVersion?: Maybe<boolean>, showAddon?: Maybe<boolean>, headline?: Maybe<string>, linkText?: Maybe<string>, linkUrl?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', hero?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, regions?: Maybe<Array<{ __typename: 'TermRegion', id: number }>>, countries?: Maybe<Array<{ __typename: 'TermCountry', id: number }>> };

export type ParagraphHeroFragmentFragment = { __typename: 'ParagraphHero', title?: Maybe<string>, subtitle?: Maybe<string>, useNegativeLogoVersion?: Maybe<boolean>, image?: Maybe<(
    { __typename: 'MediaImage', hero?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, categories: Array<{ __typename: 'ParagraphSearchCategory', id: number, title?: Maybe<string>, category?: Maybe<(
      { __typename: 'TermCategory' }
      & TermCategoryFragmentFragment
    )> }> };

export type ParagraphHotelListFragmentFragment = { __typename: 'ParagraphHotelList', id: number, limit: number, linktext?: Maybe<string>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )>, data?: Maybe<{ __typename: 'HotelConnection', items?: Maybe<Array<Maybe<(
      { __typename: 'Hotel' }
      & HotelTeaserFragmentFragment
    )>>> }>, regions?: Maybe<Array<{ __typename: 'TermRegion', id: number }>>, countries?: Maybe<Array<{ __typename: 'TermCountry', id: number }>> };

export type OfferForFrontendItemFragmentFragment = { __typename: 'Offers', id: number, body?: Maybe<string>, title: string, subtitle?: Maybe<string>, price?: Maybe<number>, image?: Maybe<(
    { __typename: 'MediaImage', imageStyle?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, dateRange?: Maybe<{ __typename: 'FieldDate', value?: Maybe<string>, end_value?: Maybe<string> }>, hotel?: Maybe<{ __typename: 'Hotel', url: string, title: string, region?: Maybe<{ __typename: 'TermRegion', name: string }>, country?: Maybe<{ __typename: 'TermCountry', name: string }>, teaserImage?: Maybe<(
      { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
      & MediaImageFragmentFragment
    )> }> };

export type OfferItemHotelFragmentFragment = { __typename: 'Hotel', id: number, title: string, url: string, region?: Maybe<{ __typename: 'TermRegion', name: string }>, country?: Maybe<{ __typename: 'TermCountry', name: string }>, teaserImage?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type OfferItemFragmentFragment = { __typename: 'Offers', id: number, price?: Maybe<number>, subtitle?: Maybe<string>, title: string, body?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, hotel?: Maybe<(
    { __typename: 'Hotel' }
    & OfferItemHotelFragmentFragment
  )> };

export type ParagraphHotelOffersFragmentFragment = { __typename: 'ParagraphHotelOffers', title?: Maybe<string>, subtitle?: Maybe<string>, data?: Maybe<{ __typename: 'OffersConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Offers' }
      & OfferItemFragmentFragment
    )>>> }> };

export type ParagraphImageFragmentFragment = { __typename: 'ParagraphImage', id: number, viewmode?: Maybe<string>, caption?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, original?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type ParagraphImageAndTextFragmentFragment = { __typename: 'ParagraphImageAndText', body?: Maybe<string>, imagePosition: string, image?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type ParagraphImageTextTeaserFragmentFragment = { __typename: 'ParagraphImageTextTeaser', title?: Maybe<string>, subtitle?: Maybe<string>, body?: Maybe<string>, linkText?: Maybe<string>, customLink?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, category?: Maybe<(
    { __typename: 'TermCategory' }
    & TermCategoryFragmentFragment
  )> };

export type ParagraphInfoBoxFragment = { __typename: 'ParagraphInfoBox', title?: Maybe<string>, text: string, colorSchema: string };

export type ParagraphInfolinoActivitiesFragmentFragment = { __typename: 'ParagraphInfolinoActivities', id: number };

export type ParagraphInfolinoContactFragmentFragment = { __typename: 'ParagraphInfolinoContact', id: number };

export type ParagraphInfolinoFeedbackFormularFragmentFragment = { __typename: 'ParagraphInfolinoFeedbackFormular', id: number, email?: Maybe<string>, ratingCategories: Array<string> };

export type ParagraphInfolinoPoIsFragmentFragment = { __typename: 'ParagraphInfolinoPOIs', id: number };

export type ParagraphInfolinoRatingFragmentFragment = { __typename: 'ParagraphInfolinoRating', id: number };

export type ParagraphInfolinoWellnessFormularFragmentFragment = { __typename: 'ParagraphInfolinoWellnessFormular', id: number, email?: Maybe<string>, treatments: Array<string>, description?: Maybe<string> };

export type ParagraphLinksFragmentFragment = { __typename: 'ParagraphLinks', links?: Maybe<Array<{ __typename: 'ParagraphLink', link?: Maybe<{ __typename: 'Link', url: string, text?: Maybe<string> }>, countries?: Maybe<Array<{ __typename: 'TermCountry', id: number }>>, regions?: Maybe<Array<{ __typename: 'TermRegion', id: number }>> }>> };

export type ParagraphMerchantListFragmentFragment = { __typename: 'ParagraphMerchantList', id: number, merchants?: Maybe<{ __typename: 'MerchantConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Merchant' }
      & MerchantTeaserFragmentFragment
    )>>> }> };

export type ParagraphNewsListFragmentFragment = { __typename: 'ParagraphNewsList', id: number, data?: Maybe<{ __typename: 'NewsConnection', items?: Maybe<Array<Maybe<(
      { __typename: 'News' }
      & NewsTeaserFragmentFragment
    )>>> }> };

export type ParagraphNewsletterFragmentFragment = { __typename: 'ParagraphNewsletter', title?: Maybe<string>, subtitle?: Maybe<string>, body?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', hero?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type ParagraphPartnerFragment = { __typename: 'ParagraphPartner', id: number };

export type ParagraphPartnerListFragment = { __typename: 'ParagraphPartnerList', id: number, title?: Maybe<string>, partner: Array<Maybe<(
    { __typename: 'TermPartner' }
    & PartnerFragmentFragment
  )>> };

export type PassListMapDataFragment = { __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
    { __typename: 'Poi' }
    & PoiTableFragment
  )>>>, countries: Array<{ __typename: 'TermCountry', id: number, name: string }>, regions: Array<{ __typename: 'TermRegion', id: number, name: string, country?: Maybe<{ __typename: 'TermCountry', id: number }> }> };

export type ParagraphPassListMapFragment = { __typename: 'ParagraphPassListMap', id: number, title?: Maybe<string>, data?: Maybe<(
    { __typename: 'PoiConnection' }
    & PassListMapDataFragment
  )>, regions?: Maybe<Array<{ __typename: 'TermRegion', id: number }>>, countries?: Maybe<Array<{ __typename: 'TermCountry', id: number }>> };

export type ParagraphPassMapFragment = { __typename: 'ParagraphPassMap', id: number, data?: Maybe<{ __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Poi' }
      & PoiMapTeaserFragmentFragment
    )>>> }> };

export type PassTableDataFragment = { __typename: 'PoiConnection', total: number, items?: Maybe<Array<Maybe<(
    { __typename: 'Poi' }
    & PoiTableFragment
  )>>>, countries: Array<{ __typename: 'TermCountry', id: number, name: string }>, regions: Array<{ __typename: 'TermRegion', id: number, name: string, country?: Maybe<{ __typename: 'TermCountry', id: number }> }> };

export type ParagraphPassTableFragment = { __typename: 'ParagraphPassTable', id: number, data?: Maybe<(
    { __typename: 'PoiConnection' }
    & PassTableDataFragment
  )>, regions?: Maybe<Array<{ __typename: 'TermRegion', id: number }>>, countries?: Maybe<Array<{ __typename: 'TermCountry', id: number }>> };

export type ParagraphPoiPassProfileFragment = { __typename: 'ParagraphPoiPassProfile', id: number, title?: Maybe<string> };

export type ParagraphProductListFragmentFragment = { __typename: 'ParagraphProductList', id: number, title?: Maybe<string>, desktopAsSlider?: Maybe<boolean>, data?: Maybe<{ __typename: 'ProductConnection', items?: Maybe<Array<Maybe<(
      { __typename: 'Product' }
      & ProductTeaserFragmentFragment
    )>>> }> };

export type ParagraphRegionTeaserListFragmentFragment = { __typename: 'ParagraphRegionTeaserList', id: number, regionTeaserListItems?: Maybe<Array<{ __typename: 'ParagraphRegionTeaserListItem', linkText?: Maybe<string>, linkUrl: string, region: { __typename: 'TermRegion', id: number, name: string, body?: Maybe<string>, location?: Maybe<{ __typename: 'FieldLocation', lat?: Maybe<number>, lng?: Maybe<number> }>, image?: Maybe<(
        { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }>, teaserLarge?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
        & MediaImageFragmentFragment
      )> } }>> };

export type ParagraphSearchByIdFragment = { __typename: 'ParagraphSearchById', title?: Maybe<string> };

export type ParagraphSearchResultsFragmentFragment = { __typename: 'ParagraphSearchResults', result?: Maybe<{ __typename: 'HotelActivityPoiConnection', total: number, items?: Maybe<Array<Maybe<(
      { __typename: 'Activity' }
      & ActivityMapTeaserFragmentFragment
      & ActivityTeaserFragmentFragment
    ) | (
      { __typename: 'Hotel' }
      & HotelMapTeaserFragmentFragment
      & HotelTeaserFragmentFragment
    ) | (
      { __typename: 'Poi' }
      & PoiMapTeaserFragmentFragment
      & PoiTeaserFragmentFragment
    )>>>, activeFilters?: Maybe<Array<Maybe<{ __typename: 'ActiveFilter', label: string, field: string, value: string }>>> }> };

export type ParagraphSearchbarFragmentFragment = { __typename: 'ParagraphSearchbar', headline?: Maybe<string>, showFilters?: Maybe<boolean>, showMapButton?: Maybe<boolean>, categoriesLinkToSearchPage?: Maybe<boolean>, showGroupSearch?: Maybe<boolean>, groupSearchTitle?: Maybe<string>, groupSearchButtonTitle?: Maybe<string>, categories: Array<{ __typename: 'ParagraphSearchCategory', title?: Maybe<string>, category?: Maybe<(
      { __typename: 'TermCategory' }
      & TermCategoryFragmentFragment
    )> }> };

export type ParagraphSidebarBlockFragment = { __typename: 'ParagraphSidebarBlock', id: number, title?: Maybe<string>, content: Array<(
    { __typename: 'ParagraphActivityPoiNearHotels' }
    & ParagraphActivityPoiNearHotelsFragment
  ) | { __typename: 'ParagraphCustomTeaserList' } | (
    { __typename: 'ParagraphImageTextTeaser' }
    & ParagraphImageTextTeaserFragmentFragment
  ) | (
    { __typename: 'ParagraphLinks' }
    & ParagraphLinksFragmentFragment
  ) | (
    { __typename: 'ParagraphText' }
    & ParagraphTextFragmentFragment
  ) | (
    { __typename: 'ParagraphAdSlot' }
    & ParagraphAdSlotFragment
  )> };

export type ParagraphTestimonialFragmentFragment = { __typename: 'ParagraphTestimonial', id: number, image?: Maybe<(
    { __typename: 'MediaImage', big?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )>, data?: Maybe<(
    { __typename: 'Rating' }
    & RatingFragmentFragment
  )> };

export type ParagraphTextFragmentFragment = { __typename: 'ParagraphText', id: number, body?: Maybe<string>, headline?: Maybe<string>, addToTableOfContents?: Maybe<boolean> };

export type AdSlotFragment = { __typename: 'TermAdSlot', slotId: string, format: string, responsive: boolean, maxHeight?: Maybe<number>, layout?: Maybe<string>, key?: Maybe<string> };

export type CommentFragment = { __typename: 'Comment', id: number, thread: string, subject?: Maybe<string>, username?: Maybe<string>, created: number, comment: string, closures?: Maybe<string>, stars?: Maybe<number>, tipps?: Maybe<string>, vehicle?: Maybe<string>, dateVisit?: Maybe<string>, parentComment?: Maybe<{ __typename: 'Comment', id: number }>, images?: Maybe<Array<Maybe<{ __typename: 'MediaImage', url: string, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string, width?: Maybe<number>, height?: Maybe<number> }> }>>> };

export type PartnerFragmentFragment = { __typename: 'TermPartner', id: number, name: string, text?: Maybe<string>, externalUrl?: Maybe<string>, image: { __typename: 'MediaImage', url: string, teaser?: Maybe<{ __typename: 'ImageDerivative', url: string, width?: Maybe<number>, height?: Maybe<number> }> } };

export type MetaTagsFragmentFragment = { __typename: 'Metatag', tag: string, attributes: { __typename: 'MetatagAttribute', name?: Maybe<string>, content?: Maybe<string>, rel?: Maybe<string>, href?: Maybe<string>, property?: Maybe<string> } };

export type TermCategoryFragmentFragment = { __typename: 'TermCategory', id: number, labelPlural: string, name: string, key?: Maybe<string>, frontendUrl?: Maybe<string>, question: string, searchPageUrl?: Maybe<string>, groupSearchPageUrl?: Maybe<string>, image?: Maybe<(
    { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
    & MediaImageFragmentFragment
  )> };

export type MediaImageFragmentFragment = { __typename: 'MediaImage', id: number, name?: Maybe<string>, copyright?: Maybe<string>, imageTitle?: Maybe<string>, imageAlt?: Maybe<string>, url: string, width: number, height: number, useNameAsCaption?: Maybe<boolean> };

export type CreateRatingMutationMutationVariables = Exact<{
  data?: Maybe<CreateRatingInput>;
}>;


export type CreateRatingMutationMutation = { __typename: 'Mutation', createRating?: Maybe<{ __typename: 'CreateRatingResult', created: boolean, errors?: Maybe<Array<{ __typename: 'Violation', field: string, message: string }>> }> };

export type CreateCommentMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename: 'Mutation', createComment?: Maybe<{ __typename: 'CreateCommentResult', errors: Array<string>, created: boolean }> };

export type CreateOrderMutationMutationVariables = Exact<{
  data?: Maybe<CreateOrderInput>;
}>;


export type CreateOrderMutationMutation = { __typename: 'Mutation', createOrder?: Maybe<{ __typename: 'CreateOrderResult', created: boolean, errors?: Maybe<Array<{ __typename: 'Violation', field: string, message: string }>> }> };

export type GetFiltersQueryQueryVariables = Exact<{
  frontend: Scalars['String'];
  category: Scalars['String'];
  filter?: Maybe<FilterInputGrouped>;
}>;


export type GetFiltersQueryQuery = { __typename: 'Query', filters?: Maybe<{ __typename: 'AutocompleteResult', countries: { __typename: 'CountryConnection', items: Array<{ __typename: 'TermCountry', id: number, name: string }> }, regions: { __typename: 'RegionConnection', items: Array<{ __typename: 'TermRegion', id: number, name: string, country?: Maybe<{ __typename: 'TermCountry', id: number }> }> }, features: { __typename: 'FeatureConnection', items: Array<{ __typename: 'TermHotelFeature', id: number, name: string } | { __typename: 'TermActivityFeature', id: number, name: string }> } }> };

export type AutoCompleteQueryQueryVariables = Exact<{
  searchQuery: Scalars['String'];
  frontend: Scalars['String'];
  category: Scalars['String'];
}>;


export type AutoCompleteQueryQuery = { __typename: 'Query', autocomplete?: Maybe<{ __typename: 'AutocompleteResult', result: { __typename: 'HotelActivityPoiConnection', items?: Maybe<Array<Maybe<{ __typename: 'Activity', id: number, title: string, url: string } | { __typename: 'Hotel', id: number, title: string, url: string } | { __typename: 'Poi', id: number, title: string }>>> }, countries: { __typename: 'CountryConnection', items: Array<{ __typename: 'TermCountry', id: number, name: string }> }, regions: { __typename: 'RegionConnection', total: number, items: Array<{ __typename: 'TermRegion', id: number, name: string }> }, geocodeResults: { __typename: 'GeocodeResult', features: Array<{ __typename: 'GeocodeResultFeature', id: string, geometry: { __typename: 'GeocodeResultFeatureGeometry', coordinates: Array<number> }, properties: { __typename: 'GeocodeResultFeatureProperties', city?: Maybe<string>, country?: Maybe<string>, name?: Maybe<string>, state?: Maybe<string>, postcode?: Maybe<string> } }> } }> };

export type CreateBookingMutationMutationVariables = Exact<{
  data?: Maybe<CreateBookingInput>;
}>;


export type CreateBookingMutationMutation = { __typename: 'Mutation', createBooking?: Maybe<{ __typename: 'CreateBookingResult', created: boolean, errors?: Maybe<Array<{ __typename: 'Violation', field: string, message: string }>> }> };

export type CreateFeedbackMutationMutationVariables = Exact<{
  data?: Maybe<CreateInfolinoFeedbackInput>;
}>;


export type CreateFeedbackMutationMutation = { __typename: 'Mutation', createInfolinoFeedback?: Maybe<{ __typename: 'CreateInfolinoFeedbackResult', created: boolean, errors?: Maybe<Array<{ __typename: 'Violation', field: string, message: string }>> }> };

export type CreateWellnessMutationMutationVariables = Exact<{
  data?: Maybe<CreateInfolinoWellnessInput>;
}>;


export type CreateWellnessMutationMutation = { __typename: 'Mutation', createInfolinoWellness?: Maybe<{ __typename: 'CreateInfolinoWellnessResult', created: boolean, errors?: Maybe<Array<{ __typename: 'Violation', field: string, message: string }>> }> };

export type AdminMenuQueryQueryVariables = Exact<{
  frontend: Scalars['String'];
}>;


export type AdminMenuQueryQuery = { __typename: 'Query', adminMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )> };

export type TeaserQueryQueryVariables = Exact<{
  route: Scalars['String'];
  frontend: Scalars['String'];
}>;


export type TeaserQueryQuery = { __typename: 'Query', route?: Maybe<{ __typename: 'RouteResult', entity?: Maybe<(
      { __typename: 'Activity' }
      & ActivityTeaserFragmentFragment
    ) | (
      { __typename: 'Hotel' }
      & HotelTeaserFragmentFragment
    ) | { __typename: 'Rating' } | { __typename: 'Offers' } | { __typename: 'Page' } | (
      { __typename: 'Poi' }
      & PoiTeaserFragmentFragment
    ) | { __typename: 'News' } | { __typename: 'Product' } | { __typename: 'Person' }> }> };

export type IdQueryQueryVariables = Exact<{
  frontend: Scalars['String'];
  id: Scalars['Int'];
}>;


export type IdQueryQuery = { __typename: 'Query', idQuery?: Maybe<string> };

export type RouteQueryQueryVariables = Exact<{
  route: Scalars['String'];
  frontend: Scalars['String'];
  menuFooter: Scalars['String'];
  menuFooterMain: Scalars['String'];
  menuMain: Scalars['String'];
  searchParameters?: Maybe<SearchParameters>;
  includeFooterMain: Scalars['Boolean'];
  isMapQuery: Scalars['Boolean'];
  activitiesInRegionFilter?: Maybe<FilterInputGrouped>;
  passTableParameters?: Maybe<PassTableParameters>;
  passMapParameters?: Maybe<PassMapParameters>;
  passListMapParameters?: Maybe<PassListMapParameters>;
}>;


export type RouteQueryQuery = { __typename: 'Query', config?: Maybe<{ __typename: 'TermFrontend', id: number, defaultActivityImage?: Maybe<(
      { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
      & MediaImageFragmentFragment
    )> }>, footerMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, footerMenuMain?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, mainMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, redirect?: Maybe<{ __typename: 'Redirect', statusCode: number, destination: string }>, route?: Maybe<{ __typename: 'RouteResult', entity?: Maybe<(
      { __typename: 'Activity' }
      & ActivityFragmentFragment
    ) | (
      { __typename: 'Hotel' }
      & HotelFragmentFragment
    ) | { __typename: 'Rating' } | { __typename: 'Offers' } | (
      { __typename: 'Page' }
      & PageFragmentFragment
    ) | (
      { __typename: 'Poi' }
      & PoiFragmentFragment
    ) | (
      { __typename: 'News' }
      & NewsFragmentFragment
    ) | (
      { __typename: 'Product' }
      & ProductFragmentFragment
    ) | (
      { __typename: 'Person' }
      & PersonFragmentFragment
    )> }>, adSlotTerms: Array<(
    { __typename: 'TermAdSlot' }
    & AdSlotFragment
  )>, footerParagraphs?: Maybe<Array<Maybe<(
    { __typename: 'ParagraphPartnerList' }
    & ParagraphPartnerListFragment
  ) | (
    { __typename: 'ParagraphFromLibrary' }
    & ParagraphFromLibraryFragment
  )>>> };

export type FulltextSearchQueryQueryVariables = Exact<{
  query: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: Maybe<FilterInputGrouped>;
  frontend: Scalars['String'];
  menuFooter: Scalars['String'];
  menuMain: Scalars['String'];
}>;


export type FulltextSearchQueryQuery = { __typename: 'Query', config?: Maybe<{ __typename: 'TermFrontend', id: number, defaultActivityImage?: Maybe<(
      { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
      & MediaImageFragmentFragment
    )> }>, footerMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, mainMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, search?: Maybe<{ __typename: 'SearchResult', result?: Maybe<{ __typename: 'HotelActivityPoiConnection', total: number, items?: Maybe<Array<Maybe<(
        { __typename: 'Activity' }
        & ActivityTeaserFragmentFragment
      ) | (
        { __typename: 'Hotel' }
        & HotelTeaserFragmentFragment
      ) | (
        { __typename: 'Poi' }
        & PoiTeaserFragmentFragment
      )>>> }> }> };

export type SearchByCategoryMapQueryQueryVariables = Exact<{
  category: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: Maybe<FilterInputGrouped>;
  frontend: Scalars['String'];
  menuFooter: Scalars['String'];
  menuMain: Scalars['String'];
  sort: Sort;
}>;


export type SearchByCategoryMapQueryQuery = { __typename: 'Query', config?: Maybe<{ __typename: 'TermFrontend', defaultActivityImage?: Maybe<(
      { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
      & MediaImageFragmentFragment
    )> }>, footerMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, mainMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, searchByCategory?: Maybe<{ __typename: 'SearchByCategoryResult', categories?: Maybe<Array<{ __typename: 'TermCategory', id: number, labelPlural: string, name: string, question: string, frontendUrl?: Maybe<string>, key?: Maybe<string> }>>, category?: Maybe<{ __typename: 'TermCategory', id: number, labelPlural: string, name: string, question: string, frontendUrl?: Maybe<string>, key?: Maybe<string> }>, result?: Maybe<{ __typename: 'HotelActivityPoiConnection', total: number, items?: Maybe<Array<Maybe<(
        { __typename: 'Activity' }
        & ActivityMapTeaserFragmentFragment
      ) | (
        { __typename: 'Hotel' }
        & HotelMapTeaserFragmentFragment
      ) | (
        { __typename: 'Poi' }
        & PoiMapTeaserFragmentFragment
      )>>>, activeFilters?: Maybe<Array<Maybe<{ __typename: 'ActiveFilter', label: string, field: string, value: string }>>> }> }> };

export type SearchByCategoryQueryQueryVariables = Exact<{
  category: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: Maybe<FilterInputGrouped>;
  frontend: Scalars['String'];
  menuFooter: Scalars['String'];
  menuMain: Scalars['String'];
  sort: Sort;
}>;


export type SearchByCategoryQueryQuery = { __typename: 'Query', config?: Maybe<{ __typename: 'TermFrontend', defaultActivityImage?: Maybe<(
      { __typename: 'MediaImage', teaser?: Maybe<{ __typename: 'ImageDerivative', url: string }> }
      & MediaImageFragmentFragment
    )> }>, footerMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, mainMenu?: Maybe<(
    { __typename: 'Menu' }
    & MenuFragmentFragment
  )>, searchByCategory?: Maybe<{ __typename: 'SearchByCategoryResult', categories?: Maybe<Array<{ __typename: 'TermCategory', id: number, labelPlural: string, name: string, question: string, frontendUrl?: Maybe<string>, key?: Maybe<string> }>>, category?: Maybe<{ __typename: 'TermCategory', id: number, labelPlural: string, name: string, question: string, frontendUrl?: Maybe<string>, key?: Maybe<string> }>, result?: Maybe<{ __typename: 'HotelActivityPoiConnection', total: number, items?: Maybe<Array<Maybe<(
        { __typename: 'Activity' }
        & ActivityTeaserFragmentFragment
      ) | (
        { __typename: 'Hotel' }
        & HotelTeaserFragmentFragment
      ) | (
        { __typename: 'Poi' }
        & PoiTeaserFragmentFragment
      )>>>, activeFilters?: Maybe<Array<Maybe<{ __typename: 'ActiveFilter', label: string, field: string, value: string }>>> }> }> };

export type InfolinoHotelFragmentFragment = { __typename: 'Hotel', title: string, id: number, activitiesFreizeithotels?: Maybe<Array<(
    { __typename: 'Activity' }
    & ActivityTeaserFragmentFragment
  )>>, poisFreizeithotels?: Maybe<Array<(
    { __typename: 'Poi' }
    & PoiTeaserFragmentFragment
  )>> };

export type InfolinoQueryQueryVariables = Exact<{
  path: Scalars['String'];
  frontend: Scalars['String'];
}>;


export type InfolinoQueryQuery = { __typename: 'Query', infolino?: Maybe<{ __typename: 'InfolinoResult', baseUrl?: Maybe<string>, imageBorder?: Maybe<boolean>, color?: Maybe<string>, hotel: (
      { __typename: 'Hotel' }
      & InfolinoHotelFragmentFragment
    ), logo?: Maybe<{ __typename: 'MediaImage', url: string }>, page?: Maybe<{ __typename: 'InfolinoPage', title: string, url: string, isHomepage: boolean, content?: Maybe<Array<(
        { __typename: 'ParagraphContainer', id: number }
        & ParagraphContainerFragmentFragment
      ) | (
        { __typename: 'ParagraphColumns', id: number }
        & ParagraphColumnsFragmentFragment
      ) | (
        { __typename: 'ParagraphImage', id: number }
        & ParagraphImageFragmentFragment
      ) | (
        { __typename: 'ParagraphImageAndText', id: number }
        & ParagraphImageAndTextFragmentFragment
      ) | (
        { __typename: 'ParagraphImageTextTeaser', id: number }
        & ParagraphImageTextTeaserFragmentFragment
      ) | (
        { __typename: 'ParagraphLinks', id: number }
        & ParagraphLinksFragmentFragment
      ) | { __typename: 'ParagraphSpacer', id: number } | (
        { __typename: 'ParagraphText', id: number }
        & ParagraphTextFragmentFragment
      ) | (
        { __typename: 'ParagraphInfolinoActivities', id: number }
        & ParagraphInfolinoActivitiesFragmentFragment
      ) | (
        { __typename: 'ParagraphInfolinoContact', id: number }
        & ParagraphInfolinoContactFragmentFragment
      ) | (
        { __typename: 'ParagraphInfolinoRating', id: number }
        & ParagraphInfolinoRatingFragmentFragment
      ) | (
        { __typename: 'ParagraphInfolinoPOIs', id: number }
        & ParagraphInfolinoPoIsFragmentFragment
      ) | (
        { __typename: 'ParagraphInfolinoWellnessFormular', id: number }
        & ParagraphInfolinoWellnessFormularFragmentFragment
      ) | (
        { __typename: 'ParagraphInfolinoFeedbackFormular', id: number }
        & ParagraphInfolinoFeedbackFormularFragmentFragment
      )>> }>, menu?: Maybe<Array<{ __typename: 'InfolinoPage', title: string, isHomepage: boolean, url: string, image: { __typename: 'MediaImage', url: string, derivative?: Maybe<{ __typename: 'ImageDerivative', url: string }> } }>> }> };

export type LoadCommentsQueryVariables = Exact<{
  entityId: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type LoadCommentsQuery = { __typename: 'Query', loadMoreComments: Array<(
    { __typename: 'Comment' }
    & CommentFragment
  )> };

export type LoadMorePassTableQueryVariables = Exact<{
  paragraphId: Scalars['Int'];
  parameters?: Maybe<PassTableParameters>;
}>;


export type LoadMorePassTableQuery = { __typename: 'Query', loadMorePassTable?: Maybe<(
    { __typename: 'PoiConnection' }
    & PassTableDataFragment
  )> };
